import { CommonService } from 'src/app/services/common/common.service';
import { ApiReturn } from './../api/apireturn';
import { Injectable, NgZone } from '@angular/core';
import { Storage } from '@ionic/storage'; // IonicStorageModule
import { Platform } from '@ionic/angular';
// need to route to another page programmatically
import { Router } from '@angular/router';  // forward to another page

// add global variables here
import * as Constants from 'src/app/services/constants/constants';
import { NotificationData, SiteStructure } from 'src/app/services/global/structure';

// import { Events } from '@ionic/angular';  // deprecated in Ionic 5
import { Events } from 'src/app/services/events/events.service';  // workaround for events

// 3rd party librarues here
import * as moment from 'moment'; 
import { TranslateService } from '@ngx-translate/core';
import { Badge } from '@ionic-native/badge/ngx';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  public isNative:boolean = false;
  public MobileAppId:number = 1; // 1=AMBIT APP;  2=PANIC ONLY APP;  3= HOTKEYS;  4=PANIC BUTTON
  // ------------------------------------------------------------------------------------------------
  // --- SPECIAL APP TYPES --- TYPICALLY FALSE -- ONLY ONE CAN BE TRUE ---
  public isPanicApp:boolean = false;  // indicates whether this represents the Ambit App or the Panic App
  public isProvisioningApp:boolean = true;  // indicates whether this represents the Ambit App or the Provisioning App
  // ------------------------------------------------------------------------------------------------
  public isPanicDisplayFromLogin:boolean = false;  // forces Panic App or Panic Mode ambit to show START 
  public isPanicInitiatedFromAmbitApp = false;

  // NEVER put this value in storage 
  public OneTimeAmbitSplash:boolean = false;  // only read from memory here directly
  public OneTimeNextPage:string = '/actions'; // NEVER make this ambitsplash -- may be overridden by the first URL entered

  // these should be available in storage
  public FederatedSessionIndex:string = "";
  public MobileUserProfile:MobileUserProfile = new MobileUserProfile();
  public OrganizationHealthRisk:OrganizationHealthRisk = new OrganizationHealthRisk();
  public AmbitConfig:AmbitConfig = new AmbitConfig();
  public UserAppConfig:UserAppConfig = new UserAppConfig();
  public PushConfig:PushConfig = new PushConfig();
  public LatestMonitor:LatestMonitor = new LatestMonitor();
  public LatestSurvey:LatestSurvey = new LatestSurvey();
  public LatestActionableForm:LatestActionableForm = new LatestActionableForm();
  public LatestEventNotification:LatestEventNotification = new LatestEventNotification();
  public LatestAmbitMessage:LatestAmbitMessage = new LatestAmbitMessage();
  
  public Language:Language = new Language();
  //public LanguageList:Array<LanguageItem>;  // the list of available languages for this mobile user
  //public LanguageList:any = []; //: Array<LanguageItem>;  // the list of available languages for this mobile user
  
  // these can be rebuilt without storage from next API call
  public HeaderDisplay:HeaderDisplay = new HeaderDisplay();
  public MobileEventCounts:MobileEventCounts = new MobileEventCounts();
  public LastApiError:LastApiError = new LastApiError();
  public NavData:NavData = new NavData();

  public SiteProximity:SiteProximity = new SiteProximity();  // GeoFence related

  public Metrics:Metrics = new Metrics();

  // private support functions and fields
  private ConvertValue:ConvertValue = new ConvertValue();
  private consoleLog:boolean = true;  // see consoleLog_global

  // ----------------------------------------------------------
  // DEBUG CONSOLE LOG FLAGS (usually set these off to false)
  // ----------------------------------------------------------
  // APP
  public consoleLog_appcomponent:boolean = false;
  // COMPONENTS
  public consoleLog_myapiinfo:boolean = false;
  public consoleLog_mygeofence:boolean = false;
  public consoleLog_mycamera:boolean = false;
  public consoleLog_myeventsite:boolean = false;
  public consoleLog_myquestionnaire:boolean = false;  // <<<<<<<<<<<<<<<<<
  public consoleLog_myfooter:boolean = false;
  public consoleLog_mygeoinfo:boolean = false;  // <<<<<<<<<<<<<<<<<<<<<<
  public consoleLog_myloading:boolean = false;
  public consoleLog_mymenubadge:boolean = false;
  public consoleLog_mysortheader:boolean = false;
  public consoleLog_mystatus:boolean = false;
  // PAGES
  public consoleLog_ambitsplash:boolean = true;
  public consoleLog_actions:boolean = false;
  public consoleLog_actionsaccess:boolean = false;
  public consoleLog_actionscheckin:boolean = false;     // <<<<<<<<<<<<<
  public consoleLog_actionsdoorcontrol:boolean = false;
  public consoleLog_actionsmedia:boolean = false;
  public consoleLog_actionsmonitor:boolean = false;  
  public consoleLog_actionspulse:boolean = false;
  public consoleLog_actionsreport:boolean = false;
  public consoleLog_actionssupport:boolean = false;
  public consoleLog_actionssurvey:boolean = false;  // <<<<<<
  public consoleLog_actionstask:boolean = false;
  public consoleLog_actionsevisitor:boolean = false;
  public consoleLog_actionsanonymous:boolean = false;
  public consoleLog_actionsconfidential:boolean = false;
  public consoleLog_ambitmessage:boolean = false;
  public consoleLog_ambitmessageitem:boolean = false;
  public consoleLog_assigned:boolean = false;
  public consoleLog_assignedMonitor:boolean = false;
  public consoleLog_assignedreport:boolean = false;
  public consoleLog_assignedreportstatus:boolean = false;
  public consoleLog_assignedsupport:boolean = false;
  public consoleLog_assignedsupportstatus:boolean = false;
  public consoleLog_attention:boolean = false;
  public consoleLog_attentionsurvey:boolean = false;  // <<<<<<
  public consoleLog_attentionactionable:boolean = false;  // <<<<<<
  public consoleLog_broadcast:boolean = false;
  public consoleLog_broadcastsurvey:boolean = false;
  public consoleLog_chatlog:boolean = false;
  public consoleLog_eventnotification:boolean = false; 
  // public consoleLog_ionicevents:boolean = true; // CANNOT USE HERE DUE TO CIRCULAR DEPENDENCY...
  // public consoleLog_eventsubscription:boolean = true;  // <<< 
  public consoleLog_login:boolean = true;  // LOGIN
  public consoleLog_redirect:boolean = true;  // REDIRECT
  public consoleLog_map:boolean = false;   //  MAP
  public consoleLog_settings:boolean = false;
  public consoleLog_submitted:boolean = false;
  // PROVIDERS & SERVICES
  public consoleLog_api:boolean = false;
  public consoleLog_authguard:boolean = false;
  public consoleLog_common:boolean = false;
  public consoleLog_connectivity:boolean = false; // NETWORK
  public consoleLog_customtranslate:boolean = false; // LANGUAGE
  public consoleLog_document:boolean = false;  // <<<<<
  public consoleLog_geolocation:boolean = false;
  public consoleLog_global:boolean = false;    // <<<<<<<<<<<< THIS object
  public consoleLog_monitoring:boolean = false;
  public consoleLog_notification:boolean = false;
  public consoleLog_pagenav:boolean = false;
  public consoleLog_pushphonegap:boolean = false;
  public consoleLog_pushfirebase:boolean = false;
  public consoleLog_runtime:boolean = false;  // <<<<<<<<<< 
  public consoleLog_theme:boolean = false;

  constructor( public storage: Storage
             , public events: Events
             , public platform: Platform
             , public translate: TranslateService
             , public zone: NgZone 
             , private badge: Badge
             , public router: Router
             //, private ionicStorageModule: IonicStorageModule
    ) 
  {
    console.log('GlobalProvider.ctor - LifeCycle');
    //this.AmbitConfig = new AmbitConfig();       // new AmbitConfig(storage)

    this.platform.ready().then(() => {
      this.InitializeProvider();
    });
  }

  public InitializeProvider()
  {
    // ref: https://github.com/ionic-team/ionic-storage
    // To make sure the storage system is ready before using, call Storage.ready(). You must be on 1.1.7 or greater to use the ready() method.

    this.storage.ready().then(() => 
    {
      console.log('GlobalProvider.InitializeProvider - LifeCycle: STORAGE IS READY!');
      this.consoleLog = this.consoleLog_global;  // MUST come after the declarations above
    });
  }

  public ClearGlobalAndStorage(context:string)
  {
    //if (this.consoleLog) 
    console.log("global.ClearGlobalAndStorage - " + context);

    // typically called on a fresh login or logout

    this.FederatedSessionIndex = "";

    // these should be available in storage
    //this.MobileUserProfile = new MobileUserProfile();
    this.MobileUserProfile.ClearObject();
    //this.SetStorageObject('MobileUserProfile', this.MobileUserProfile);
    this.OrganizationHealthRisk.ClearObject();

    this.AmbitConfig = new AmbitConfig();
    //this.SetStorageObject('AmbitConfig', this.AmbitConfig);

    //this.UserAppConfig = new UserAppConfig();
    //this.SetStorageObject('UserAppConfig', this.UserAppConfig);

    //this.PushConfig = new PushConfig();
    //this.SetStorageObject('PushConfig', this.PushConfig);

    this.LatestSurvey = new LatestSurvey();
    //this.SetStorageObject('LatestSurvey', this.LatestSurvey);

    this.LatestActionableForm = new LatestActionableForm();
    //this.SetStorageObject('LatestActionableForm', this.LatestActionableForm);
    
    //this.LanguageData = new LanguageData();
    //this.SetStorageObject('LanguageData', this.LanguageData);
    
    // these can be rebuilt without storage from next API call
    this.HeaderDisplay = new HeaderDisplay();
    //this.SetStorageObject('HeaderDisplay', this.HeaderDisplay);

    this.MobileEventCounts = new MobileEventCounts();
    //this.events.publish('isMobileEventCounts', { MobileEventCounts: this.MobileEventCounts } );
    
    //this.LastApiError = new LastApiError();
    //this.SetStorageObject('LastApiError', this.LastApiError);

    this.NavData = new NavData();
    //this.SetStorageObject('NavData', this.NavData);

    this.ClearStorageObject("ClearGlobalAndStorage:" + context);
  }

  // --------------------------------------------------------------
  /*
  public PublishMobileEventCounts()
  {
    //this.MobileEventCounts.CalculateResponseRequiredTotal();
    //this.events.publish('isMobileEventCounts', { MobileEventCounts: this.MobileEventCounts } );
    this.SetAppIconBadgeCount();
  }
  */

  public SetAppIconBadgeCount()
  {
    if (this.consoleLog) console.log("global.SetAppIconBadgeCount");
    try
    {
      if (this.isNative)
      {
        if (this.consoleLog) console.log("global.SetAppIconBadgeCount - NATIVE - about to set");
        let newCount = this.MobileEventCounts.ResponseRequiredTotal.Total;
        this.badge.set(newCount);
        //this.badge.increase(1);
        //this.badge.clear();
      }
      else
      {
        if (this.consoleLog) console.log("global.SetAppIconBadgeCount - BROWSER - cannot set");
      }
    }
    catch (error)
    {
      console.warn("global.SetAppIconBadgeCount ERROR", error);
    }
  }
  
  public ChangeCount_Assigned(PriorityFlag:boolean, CountValueChange:number)
  {
    this.MobileEventCounts.Assigned.ChangeCount(PriorityFlag, CountValueChange);
    this.MobileEventCounts.ResponseRequiredTotal.ChangeCount(PriorityFlag, CountValueChange);
    this.SetAppIconBadgeCount(); // this.PublishMobileEventCounts();
  }

  public ChangeCount_AmbitMessage(PriorityFlag:boolean, CountValueChange:number)
  {
    this.MobileEventCounts.AmbitMessage.ChangeCount(PriorityFlag, CountValueChange);
    this.MobileEventCounts.ResponseRequiredTotal.ChangeCount(PriorityFlag, CountValueChange);
    this.SetAppIconBadgeCount(); // this.PublishMobileEventCounts();
  }

  public ChangeCount_Broadcasted(PriorityFlag:boolean, CountValueChange:number)
  {
    this.MobileEventCounts.Broadcasted.ChangeCount(PriorityFlag, CountValueChange);
    this.MobileEventCounts.ResponseRequiredTotal.ChangeCount(PriorityFlag, CountValueChange);
    this.SetAppIconBadgeCount(); // this.PublishMobileEventCounts();
  }

  public ChangeCount_EventNotification(PriorityFlag:boolean, CountValueChange:number)
  {
    this.MobileEventCounts.EventNotification.ChangeCount(PriorityFlag, CountValueChange);
    this.MobileEventCounts.ResponseRequiredTotal.ChangeCount(PriorityFlag, CountValueChange);
    this.SetAppIconBadgeCount(); // this.PublishMobileEventCounts();
  }


  // --------------------------------------------------------------
  public VerifyActiveLoginFromTransientMemory()
  {
    if (this.consoleLog) console.log("global.VerifyActiveLoginFromTransientMemory");
    if (this.MobileUserProfile.ActiveLogin !== true) 
    { 
      // this is okay, as the user may not be logged in yet
      return false; 
    }

    // ------------------------------------------------
    // at this point the user login is ACTIVE
    // ------------------------------------------------
    
    if (this.MobileUserProfile.MobileDeviceGuid === "") 
    { 
      // this is UNEXPECTED as an active user should have MobileUserId
      console.error("global.VerifyActiveLoginFromTransientMemory - expected MobileDeviceGuid for Active Login");
      alert("MobileDeviceGuid is missing");
      return false; 
    }

    if (this.MobileUserProfile.MobileUserId === 0) 
    { 
      // this is UNEXPECTED as an active user should have MobileUserId
      console.error("global.VerifyActiveLoginFromTransientMemory - expected MobileUserId for Active Login");
      alert("MobileUserId is missing");
      return false; 
    }

    if (this.consoleLog) console.log("global.VerifyActiveLoginFromTransientMemory - ACTIVE LOGIN");
    return true;
  }
  // --------------------------------------------------------------
  public SetStorageObject_MobileUserProfile_ActiveLogin(MobileDeviceGuid:string, MobileDeviceId:number, MobileUserId:number, OrganizationId:number, OrganizationCode:string )
  {
    if (this.consoleLog) console.log("global.SetStorageObject_MobileUserProfile_ActiveLogin - MobileDeviceGuid:" + MobileDeviceGuid + " MobileUserId:" + MobileUserId);
    this.MobileUserProfile.ActiveLogin = true;
    this.MobileUserProfile.MobileDeviceGuid = MobileDeviceGuid;
    this.MobileUserProfile.MobileDeviceId = MobileDeviceId;
    this.MobileUserProfile.MobileUserId = MobileUserId;

    // other important fields used within the api calls
    this.MobileUserProfile.OrganizationId = OrganizationId;
    this.MobileUserProfile.OrganizationCode = OrganizationCode;  

    if (this.consoleLog) console.log("global.SetStorageObject_MobileUserProfile_ActiveLogin: setting storage", this.MobileUserProfile);
    this.storage.set('MobileUserProfile', this.MobileUserProfile); 
  }
  // --------------------------------------------------------------
  public SetStorageObject_MobileUserProfile_LoggedOut()
  {
    if (this.consoleLog) console.log("global.SetStorageObject_MobileUserProfile_LoggedOut");
    this.MobileUserProfile = new MobileUserProfile(); // clear out
    this.MobileUserProfile.ActiveLogin = false;

    if (this.consoleLog) console.log("global.SetStorageObject_MobileUserProfile_LoggedOut: setting storage", this.MobileUserProfile);
    this.storage.set('MobileUserProfile', this.MobileUserProfile); 
  }
  // --------------------------------------------------------------

  // ==============================================================
  // ===========   PRIME ALL MISSING DATA FROM STORAGE ============
  // ==============================================================
  public PrimeDataFromStorage(): Promise<boolean> 
  {
    if (this.consoleLog) console.log("global.PrimeDataFromStorage");

    return Promise.all(
      [ this.storage.get('MobileUserProfile')
      , this.storage.get('AmbitConfig')
      , this.storage.get('UserAppConfig')
      , this.storage.get('PushConfig')
      , this.storage.get('LatestSurvey')
      , this.storage.get('LatestActionableForm')
      , this.storage.get('Language')
      , this.storage.get('NavData')
      , this.storage.get('MobileEventCounts')
      , this.storage.get('storedOrganizationHealthRisk')
      , this.storage.get('FederatedSessionIndex')
      ])
      .then( 
        ([ storedMobileUserProfile
         , storedAmbitConfig
         , storedUserAppConfig
         , storedPushConfig
         , storedLatestSurvey
         , storedLatestActionableForm
         , storedLanguage
         , storedNavData
         , storedMobileEventCounts
         , storedOrganizationHealthRisk
         , storedFederatedSessionIndex
        ]) => 
      {
        if (this.consoleLog) console.log('global.PrimeDataFromStorage: retrieved ok - storedMobileUserProfile', storedMobileUserProfile);
        let MobileUserResult:boolean = this.MobileUserProfile.SetFromStorage(storedMobileUserProfile);

        if (this.consoleLog) console.log('global.PrimeDataFromStorage: retrieved ok - storedAmbitConfig', storedAmbitConfig);
        let AmbitConfigResult:boolean = this.AmbitConfig.SetFromStorage(storedAmbitConfig);

        if (this.consoleLog) console.log('global.PrimeDataFromStorage: retrieved ok - storedUserAppConfig', storedUserAppConfig);
        let UserAppConfigResult:boolean = this.UserAppConfig.SetFromStorage(storedUserAppConfig);

        if (this.consoleLog) console.log('global.PrimeDataFromStorage: retrieved ok - storedPushConfig', storedPushConfig);
        let PushConfigResult:boolean = this.PushConfig.SetFromStorage(storedPushConfig);

        if (this.consoleLog) console.log('global.PrimeDataFromStorage: retrieved ok - storedLanguage', storedLanguage);
        let LanguageResult:boolean = this.Language.SetFromStorage(storedLanguage);

        if (this.consoleLog) console.log('global.PrimeDataFromStorage: retrieved ok - storedLatestSurvey', storedLatestSurvey);
        let LatestSurveyResult:boolean = this.LatestSurvey.SetFromStorage(storedLatestSurvey);

        if (this.consoleLog) console.log('global.PrimeDataFromStorage: retrieved ok - storedLatestActionableForm', storedLatestActionableForm);
        let LatestActionableFormResult:boolean = this.LatestActionableForm.SetFromStorage(storedLatestActionableForm);

        if (this.consoleLog) console.log('global.PrimeDataFromStorage: retrieved ok - storedNavData', storedNavData);
        let NavDataResult:boolean = this.NavData.SetFromStorage(storedNavData);

        if (this.consoleLog) console.log('global.PrimeDataFromStorage: retrieved ok - storedMobileEventCounts', storedMobileEventCounts);
        let MobileEventCountsResult:boolean = this.MobileEventCounts.SetFromStorage(storedMobileEventCounts);

        if (this.consoleLog) console.log('global.PrimeDataFromStorage: retrieved ok - storedOrganizationHealthRisk', storedOrganizationHealthRisk);
        let OrganizationHealthRisk:boolean = this.OrganizationHealthRisk.SetFromStorage(storedOrganizationHealthRisk);

        if (storedFederatedSessionIndex) {
          this.FederatedSessionIndex = storedFederatedSessionIndex;
        }

        return MobileUserResult;  // this is the only one that really matters
      })
      ;
  }

  public SetStorageObject_Dashboard(apiResponse: any, functionName: string)
  {
    if (functionName !== "GetDashboardStatusForMobile")
    {
      if (this.consoleLog) console.log("global.SetStorageObject_Dashboard: not applicable for " + functionName, apiResponse);
      return;
    }
    // if (this.consoleLog) 
    console.log("global.SetStorageObject_Dashboard", apiResponse);
    this.SetStorageObject_MobileUserProfile(apiResponse);
    this.SetStorageObject_AppDisplayInfo(apiResponse);
    this.SetStorageObject_AmbitConfig(apiResponse);
    this.SetStorageObject_OrganizationHealthRisk(apiResponse);
    //this.globalProvider.SetStorageObject_LanguageData(data);
  }
  
  // --------------------------------------------------------------
  public SetStorageObject_MobileUserProfile(apiResponse)
  {
    // if (this.consoleLog) 
    if (this.consoleLog) console.log("global.SetStorageObject_MobileUserProfile", apiResponse);

    if (!apiResponse)
    {
      console.error("SetStorageObject_MobileUserProfile: No data passed");
      return;
    }

    this.MobileUserProfile.SetFromApiResponse(apiResponse);  // data is the ApiResponse object
    //this.SetStorageObject('MobileUserProfile', this.MobileUserProfile);
  }
  // --------------------------------------------------------------
  public SetStorageObject_OrganizationHealthRisk(apiResponse)
  {
    // if (this.consoleLog) 
    if (this.consoleLog) console.log("global.SetStorageObject_OrganizationHealthRisk", apiResponse);

    if (!apiResponse)
    {
      console.error("SetStorageObject_OrganizationHealthRisk: No data passed");
      return;
    }

    this.OrganizationHealthRisk.SetFromApiResponse(apiResponse, this.MobileUserProfile.HealthRiskFlag);  // data is the ApiResponse object
    //this.SetStorageObject('OrganizationHealthRisk', this.MobileUserProfile);
  }

  // --------------------------------------------------------------
  public CheckMobileUserProfileExists(): Promise<boolean>
  {
    if (this.consoleLog) console.log("global.CheckMobileUserProfileExists");

    if (this.MobileUserProfile.ActiveLogin === true)
    {
      if (this.consoleLog) console.log('global.CheckMobileUserProfileExists: retrieved ok - storedMobileUserProfile', this.MobileUserProfile);
      return Promise.resolve(true);
    }

    //return this.PrimeDataFromStorage_MobileUserProfile();
    return this.PrimeDataFromStorage();
  }

  public PrimeDataFromStorage_MobileUserProfile(): Promise<boolean> 
  {
    if (this.consoleLog) console.log("global.PrimeDataFromStorage_MobileUserProfile");

    return Promise.all(
      [ this.storage.get('MobileUserProfile')
      ])
      .then( 
        ([ storedMobileUserProfile ]) => 
      {
        if (this.consoleLog) console.log('global.PrimeDataFromStorage_MobileUserProfile: values retrieved ok', storedMobileUserProfile);
        return this.MobileUserProfile.SetFromStorage(storedMobileUserProfile);
      })
      ;
  }
  // --------------------------------------------------------------
  public SetStorageObject_LatestSurvey(ActiveSurveyBroadcastId:number, ActiveSurveyRecipientId:number, ActiveSurveyResponseStatusCode:string) //(data:any)
  {
    //if (this.consoleLog) 
    console.log("global.SetStorageObject_LatestSurvey - ActiveSurveyBroadcastId:" + ActiveSurveyBroadcastId);

    this.LatestSurvey.SetLatestSeen(ActiveSurveyBroadcastId, ActiveSurveyRecipientId, ActiveSurveyResponseStatusCode);
    this.SetStorageObject('LatestSurvey', this.LatestSurvey);
  }
  // --------------------------------------------------------------
  public SetStorageObject_LatestActionableForm(ActiveActionableBroadcastId:number, ActiveActionableRecipientId:number, ActiveActionableResponseStatusCode:string) //(data:any)
  {
    //if (this.consoleLog) 
    console.log("global.SetStorageObject_LatestActionableForm - ActiveActionableBroadcastId:" + ActiveActionableBroadcastId);

    this.LatestActionableForm.SetLatestSeen(ActiveActionableBroadcastId, ActiveActionableRecipientId, ActiveActionableResponseStatusCode);
    this.SetStorageObject('LatestActionableForm', this.LatestActionableForm);
  }
  // --------------------------------------------------------------
  public SetStorageObject_LatestEventNotification(ActiveAmbitMessageId:number, ActiveEventId:number, ActiveEventNotificationStatusCode:string) //(data:any)
  {
    //if (this.consoleLog) 
    console.log("global.SetStorageObject_LatestEventNotification - ActiveAmbitMessageId:" + ActiveAmbitMessageId);

    // change this later to be "ActiveEventNotificationId" once we create a separate table for these messages?
    this.LatestEventNotification.SetLatestSeen(ActiveAmbitMessageId, ActiveEventId, ActiveEventNotificationStatusCode);
    this.SetStorageObject('LatestEventNotification', this.LatestEventNotification);
  }
  // --------------------------------------------------------------
  public SetStorageObject_LatestAmbitMessage(ActiveAmbitMessageId:number, ActiveEventId:number, ActiveAmbitMessageStatusCode:string) //(data:any)
  {
    //if (this.consoleLog) 
    console.log("global.SetStorageObject_LatestAmbitMessage - ActiveAmbitMessageId:" + ActiveAmbitMessageId);

    this.LatestAmbitMessage.SetLatestSeen(ActiveAmbitMessageId, ActiveEventId, ActiveAmbitMessageStatusCode);
    this.SetStorageObject('LatestAmbitMessage', this.LatestAmbitMessage);
  }

  // --------------------------------------------------------------
  public SetStorageObject_ApiData(data:any, dataName:string)
  {
    if (this.consoleLog) console.log("global.SetStorageObject_ApiData: " + dataName);
    if (!data)
    {
      console.error("StoreApiData: No data passed for " + dataName);
      return;
    }

    this.storage.set(dataName, data);
  }







  // --------------------------------------------------------------

  public SetStorageObject_PushConfig_Device(DevicePushRegType:string, DevicePushRegId:string)
  {
    console.log("global.SetStorageObject_PushConfig_Device - DevicePushRegType:" + DevicePushRegType + " DevicePushRegId:" + DevicePushRegId);
    if (!this.PushConfig) { return; }
    this.PushConfig.SetDevice(DevicePushRegType, DevicePushRegId);
    this.SetStorageObject('PushConfig', this.PushConfig);
  }
  public SetStorageObject_PushConfig_Registration(AmbitPushRegistrationFlag:boolean, AmbitPushRegistrationStatus:string)
  {
    console.log("global.SetStorageObject_PushConfig_Registration - AmbitPushRegistrationFlag:" + AmbitPushRegistrationFlag + " AmbitPushRegistrationStatus:" + AmbitPushRegistrationStatus);
    if (!this.PushConfig) { return; }
    this.PushConfig.SetRegistration(AmbitPushRegistrationFlag, AmbitPushRegistrationStatus);
    this.SetStorageObject('PushConfig', this.PushConfig);
  }
  public SetStorageObject_PushConfig_LatestReceived(LatestNotificationType:string, LatestNotificationStatus:string, LatestNotificationEventId:number)
  {
    console.log("global.SetStorageObject_PushConfig_LatestReceived - LatestNotificationType:" + LatestNotificationType 
             + " LatestNotificationStatus:" + LatestNotificationStatus + " LatestNotificationEventId:" + LatestNotificationEventId);
    if (!this.PushConfig) { return; }
    this.PushConfig.SetLatestReceived(LatestNotificationType, LatestNotificationStatus, LatestNotificationEventId);
    this.SetStorageObject('PushConfig', this.PushConfig);
  }
  
  // --------------------------------------------------------------
  public SetStorageObject_AmbitConfig_SurveyBroadcastLicensedFlag(SurveyBroadcastLicensedFlag:boolean)
  {
    this.AmbitConfig.SetSurveyBroadcastLicensedFlag(SurveyBroadcastLicensedFlag);
    this.SetStorageObject('AmbitConfig', this.AmbitConfig);
  }

  public SetStorageObject_AmbitConfig_MobileMediaLicensedFlag(MediaFeatureLicensedFlag:boolean)
  {
    this.AmbitConfig.SetMediaFeatureLicensedFlag(MediaFeatureLicensedFlag);
    this.SetStorageObject('AmbitConfig', this.AmbitConfig);
  }

  public SetStorageObject_AmbitConfig_CheckinSiteIndoorFlag(CheckinSiteIndoorFlag:boolean)
  {
    this.AmbitConfig.SetCheckinSiteIndoorFlag(CheckinSiteIndoorFlag);
    this.SetStorageObject('AmbitConfig', this.AmbitConfig);
  }


  public SetStorageObject_AmbitConfig(apiResponse:any)
  {
    if (this.consoleLog) console.log("global.MobileEventCounts.SetStorageObject_AmbitConfig", apiResponse);
    this.AmbitConfig.SetFromApiResponse(apiResponse);
    this.SetStorageObject('AmbitConfig', this.AmbitConfig);
  }

  public SetStorageObject_SiteProximity(apiResponse:any)
  {
    if (this.consoleLog) console.log("global.MobileEventCounts.SetStorageObject_SiteProximity", apiResponse);
    this.SiteProximity.SetFromApiResponse(apiResponse);
    this.SetStorageObject('SiteProximity', this.SiteProximity);
  }

  // --------------------------------------------------------------
  public SetStorageObject_MobileEventCounts(apiResponse:any)
  {
    this.MobileEventCounts.SetFromApiResponse(apiResponse);

    // notify the side menu and top bar that counts need to be updated...
    // - ToDo check whether this is necessary and only do when counts have *changed*
    if (this.consoleLog) console.log("global.MobileEventCounts.SetFromApiResponse - publish count update");
    this.SetAppIconBadgeCount(); // this.PublishMobileEventCounts();
    // this.events.publish('isMobileEventCounts', { MobileEventCounts: this.MobileEventCounts } );
    
    this.SetStorageObject('MobileEventCounts', this.MobileEventCounts);
  }
  // --------------------------------------------------------------
  public SetStorageObject_LanguageData(LanguageId:number, LanguageCode:string, LanguageName:string, LanguageRtl:boolean, 
                                      MomentLocale:string, languageData:any)
  {
    // NOTE: language data is extracted from the ApiResponse already by the "customtranslateloaderservice" 
    if (this.consoleLog) console.log("global.SetStorageObject_LanguageData - check if any language data");
    if (this.Language.SetLanguageData(LanguageId, LanguageCode, LanguageName, LanguageRtl, MomentLocale, languageData))
    {
      this.SetStorageObject('Language', this.Language);
    }
    else
    {
      if (this.consoleLog) console.log("global.SetStorageObject_LanguageData - no new language data");
    }
  }
  // --------------------------------------------------------------
  public SetStorageObject_UserAppConfig_AutoSelectSite(AutoSelectEventSite:boolean)
  {
    this.UserAppConfig.SetAutoSelectSite(AutoSelectEventSite);
    this.SetStorageObject('UserAppConfig', this.UserAppConfig);
  }
  // --------------------------------------------------------------
  public SetStorageObject_UserAppConfig_IsActionsList(IsActionsList:boolean)
  {
    this.UserAppConfig.IsActionsList = IsActionsList;
    this.SetStorageObject('UserAppConfig', this.UserAppConfig);
  }
  // --------------------------------------------------------------
  public StoreNavData()  // just call this in any "GetNav" new landing page as a way to get home
  {
    // save the last used nav data
    this.SetStorageObject('NavData', this.NavData);

    // make a copy of the navdata before clearing the global view
    //let navData:NavData = new NavData();
    //Object.assign(navData, this.NavData);
    //this.NavData.Initialize(); // clear after all data read in

    // return the nav data used for the new page's local use
    //return navData;
  }

  public async ClearStoredNavData() {
    await this.storage.ready();
    await this.storage.remove('NavData');
  }



  // --------------------------------------------------------------
  // Combined call for convenience only
  // --------------------------------------------------------------
  public SetStorageObject_AppDisplayInfo(apiResponse)
  {
    if (this.consoleLog) console.log("global.SetStorageObject_AppDisplayInfo", apiResponse);
    if (!apiResponse)
    {
      console.error("SetStorageObject_AppDisplayInfo: No data passed");
      return;
    }

    this.SetStorageObject_AmbitConfig(apiResponse);
    this.SetStorageObject_MobileEventCounts(apiResponse);
    //this.SetStorageObject_LanguageData(apiResponse);
  }
  // --------------------------------------------------------------

  public SetStorageObject_FederatedSessionIndex(federatedSessionIndex) {
    this.SetStorageObject("FederatedSessionIndex", federatedSessionIndex);
  }

  public GetStorageObject_FederatedSessionIndex() {
    return this.GetStorageObject("FederatedSessionIndex");
  }


  // --------------------------------------------------------------
  // ------------------  STORAGE FUNCTION   -----------------------
  // --------------------------------------------------------------
  // Note:  we need to set the storage object at the global level (rather than sub-level)
  //        because we want to avoid having to inject the storage object into each sub-level
  SetStorageObject(name:string, value:any)
  {
    if (this.consoleLog) console.log("global.SetStorageObject(" + name + ")", value); 
    // e.g. this.storage.set('MobileUserProfile', this.MobileUserProfile); 
    this.storage.set(name, value); 
  }

  GetStorageObject(name:string)
  {
    if (this.consoleLog) console.log("global.GetStorageObject(" + name + ")"); 
    return this.storage.get(name); 
  }

  ClearStorageObject(context:string)
  {
    //if (this.consoleLog) 
    console.log("global.SetStorageObject - " + context); 
    // e.g. this.storage.set('MobileUserProfile', this.MobileUserProfile); 
    this.storage.clear(); 
  }

  // --------------------------------------------------------------
  // ------------------  PRIME FROM STORAGE   ---------------------
  // --------------------------------------------------------------
  // these were copied over from the respective pages
  // so we can avoid referencing the storage directly there
  

  GetActiveLanguageId():number
  {
    if (this.Language.LanguageId > 0)
    {
      // according to this app
      return this.Language.LanguageId;
    }
    else if (this.MobileUserProfile.LanguageId > 0)
    {
      // this is according to the cloud server
      return this.MobileUserProfile.LanguageId;
    }
  }

  GetActiveMomentLocale():string
  {
    if (this.Language.LanguageId > 0)
    {
      // according to this app
      return this.Language.MomentLocale;
    }
    else if (this.MobileUserProfile.LanguageId > 0)
    {
      // this is according to the cloud server
      return this.MobileUserProfile.MomentLocale;
    }
  }

  IsShowPanicConfirmation():boolean
  {
    if (!AmbitConfig) { return false; }
    return this.AmbitConfig.IsShowPanicConfirmation();
  }

  GetPanicModeConfigInfo():string
  {
    if (!AmbitConfig) { return ""; }
    return this.AmbitConfig.GetPanicModeConfigInfo(this.isPanicApp);
  }
  
  GetPanicModeOnlyFlag(context:string):boolean
  {
    if (this.consoleLog) console.log("global.GetPanicModeOnlyFlag" + " - " + context);
    if (!AmbitConfig) { return false; }
    console.log("global.GetPanicModeOnlyFlag: " + this.AmbitConfig.PanicModeOnlyFlag + " - " + context);
    //alert("global.GetPanicModeOnlyFlag: " + this.AmbitConfig.PanicModeOnlyFlag + " - " + context);
    return this.AmbitConfig.PanicModeOnlyFlag;
  }
  
  GetMonitorMustUsePanicFlowFlag(context:string):boolean
  {
    if (this.consoleLog) console.log("global.MonitorMustUsePanicFlowFlag" + " - " + context);
    if (!AmbitConfig) { return false; }
    if (this.consoleLog) console.log("global.MonitorMustUsePanicFlowFlag: " + this.AmbitConfig.MonitorMustUsePanicFlowFlag + " - " + context);
    return this.AmbitConfig.MonitorMustUsePanicFlowFlag;
  }

  GetMonitorWarnDisplayFlag(context:string):boolean
  {
    if (this.consoleLog) console.log("global.MonitorWarnDisplayFlag" + " - " + context);
    if (!AmbitConfig) { return false; }
    if (this.consoleLog) console.log("global.MonitorWarnDisplayFlag: " + this.AmbitConfig.MonitorWarnDisplayFlag + " - " + context);
    return this.AmbitConfig.MonitorWarnDisplayFlag;
  }

  GetEnableMetricsFlag(context:string):boolean
  {
    if (this.consoleLog) console.log("global.EnableMetricsFlag" + " - " + context);
    if (!AmbitConfig) { return false; }
    if (this.consoleLog) console.log("global.EnableMetricsFlag: " + this.AmbitConfig.EnableMetricsFlag + " - " + context);
    return this.AmbitConfig.EnableMetricsFlag;
  }

  GetMetrics_QueryString():string
  {
    if (this.consoleLog) console.log("global.GetMetrics_QueryString");
    if (!AmbitConfig) { return ''; }
    if (!Metrics) { return ''; }

    if (!this.AmbitConfig.EnableMetricsFlag)
    {
      if (this.consoleLog) console.log("global.GetMetrics_QueryString - " + " Metrics NOT enabled");
      return '';
    }
    if (this.consoleLog) console.log("global.GetMetrics_QueryString: " + this.Metrics.GetQueryString());
    return this.Metrics.GetQueryString();
  }
      
  GetPanicDelayCountdownSeconds(context:string):number
  {
    if (this.consoleLog) console.log("global.GetPanicDelayCountdownSeconds" + " - " + context);
    let defaultSeconds:number = 5;
    if (!AmbitConfig) 
    { 
      console.warn("global.GetPanicDelayCountdownSeconds: MISSING CONFIG - use default " + defaultSeconds + " - " + context);
      return defaultSeconds; 
    }

    if (this.AmbitConfig.PanicDelayCountdownSeconds <= 0)
    {
      console.warn("global.GetPanicDelayCountdownSeconds: value is zero - use default " + defaultSeconds + " - " + context);
      return defaultSeconds; 
    }

    console.log("global.GetPanicDelayCountdownSeconds: " + this.AmbitConfig.PanicDelayCountdownSeconds + " - " + context);
    return this.AmbitConfig.PanicDelayCountdownSeconds;
  }

  CheckAppPanicMode(context:string):boolean
  {
    if (this.consoleLog) console.log("global.CheckAppPanicMode - " + context);

    if (this.isPanicApp === true)
    {
      console.warn("This is the special PANIC APP (not the ambit app) - " + context);
      if (this.consoleLog) console.log("global.CheckAppPanicMode: TRUE (Panic App) - " + context);
      return true;
    }

    if (this.AmbitConfig.PanicModeOnlyFlag === true)
    {
      console.warn("App restricted to PANIC MODE ONLY");
      if (this.consoleLog) console.log("global.CheckAppPanicMode: TRUE (Ambit app PanicModeOnlyFlag) - " + context);
      return true;
    }

    if (this.consoleLog) console.log("global.CheckAppPanicMode: FALSE - " + context);
    return false;
  }

  CheckProvisioningAppMode(context:string):boolean
  {
    if (this.consoleLog) console.log("global.CheckProvisioningAppMode - " + context);

    if (this.isProvisioningApp === true)
    {
      console.warn("This is for PROVISIONING user only (not the ambit app) - " + context);
      if (this.consoleLog) console.log("global.CheckProvisioningAppMode: TRUE (Panic App) - " + context);
      return true;
    }

    if (this.consoleLog) console.log("global.CheckProvisioningAppMode: FALSE - " + context);
    return false;
  }

  // this is similar to ambitsplash.SetFirstPage
  CheckSpecialAppMode(context: string)
  {
    if (this.consoleLog) console.log("global.CheckSpecialAppMode - " + context);

    // GO TO PANIC PAGE IF USER'S PROFILE LIMITED TO PANIC
    if (this.CheckAppPanicMode("global.CheckSpecialAppMode-" + context))
    {
      if (this.consoleLog) console.log("global.CheckSpecialAppMode: PANIC - " + context);
      this.router.navigateByUrl('/actions-monitor');  // '/actions-panic'
    }

    // GO TO PROVISIONING PAGE IF THIS BUILD IS FOR THAT PURPOSE ONLY
    if (this.CheckProvisioningAppMode("global.CheckSpecialAppMode-" + context))
    {
      if (this.consoleLog) console.log("global.CheckSpecialAppMode: PROVISIONING - " + context);
      this.router.navigateByUrl('/login');  // /provisioning
    }

    if (this.consoleLog) console.log("global.CheckSpecialAppMode - " + context + " - REGULAR APP");
  }


  SetPanicInitiatedFromAmbitAppFlag(value:boolean)
  {
    if (this.consoleLog) console.log("global.SetPanicInitiatedFromAmbitAppFlag: " + value);
    this.isPanicInitiatedFromAmbitApp = value;
  }

  GetPanicInitiatedFromAmbitAppFlag(context:string):boolean
  {
    if (this.consoleLog) console.log("global.GetPanicInitiatedFromAmbitAppFlag: " + this.isPanicInitiatedFromAmbitApp + " - " + context);
    return this.isPanicInitiatedFromAmbitApp;

    /*
    if (!NavData) { return false; }
    let PanicInitiatedFromAmbitAppFlag:boolean = this.NavData.GetPanicInitiatedFromAmbitAppFlag();
    console.log("global.GetPanicInitiatedFromAmbitAppFlag: " + PanicInitiatedFromAmbitAppFlag);
    alert("global.PanicInitiatedFromAmbitAppFlag: " + PanicInitiatedFromAmbitAppFlag);
    return PanicInitiatedFromAmbitAppFlag;
    */
  }

  /*
  public IsBeyondGeofence():boolean
  {
    return this.SiteProximity.IsMobileUserBeyondGeofenceRange();  // now check if the nearest geofence site is within range
  }
  public IsBeyondGeofenceMonitor():boolean
  {
    if (!this.AmbitConfig.GeofenceMonitorFlag) { return false; }  // check if there is any restrition first
    return this.SiteProximity.IsMobileUserBeyondGeofenceRange();  // now check if the nearest geofence site is within range
  }
  public IsBeyondGeofenceSupport():boolean
  {
    if (!this.AmbitConfig.GeofenceSupportFlag) { return false; }  // check if there is any restrition first
    return this.SiteProximity.IsMobileUserBeyondGeofenceRange();  // now check if the nearest geofence site is within range
  }
  public IsBeyondGeofenceReport():boolean
  {
    if (!this.AmbitConfig.GeofenceReportFlag) { return false; }  // check if there is any restrition first
    return this.SiteProximity.IsMobileUserBeyondGeofenceRange();  // now check if the nearest geofence site is within range
  }
  public IsBeyondGeofenceCheckin():boolean
  {
    if (!this.AmbitConfig.GeofenceCheckinFlag) { return false; }  // check if there is any restrition first
    return this.SiteProximity.IsMobileUserBeyondGeofenceRange();  // now check if the nearest geofence site is within range
  }
  public IsBeyondGeofenceAccess():boolean
  {
    if (!this.AmbitConfig.GeofenceAccessFlag) { return false; }  // check if there is any restrition first
    return this.SiteProximity.IsMobileUserBeyondGeofenceRange();  // now check if the nearest geofence site is within range
  }
  public IsBeyondGeofenceDoorControl():boolean
  {
    if (!this.AmbitConfig.GeofenceDoorControlFlag) { return false; }  // check if there is any restrition first
    return this.SiteProximity.IsMobileUserBeyondGeofenceRange();  // now check if the nearest geofence site is within range
  }
  */
}


@Injectable()
export class MobileUserProfile 
{
  // special identifier fields required for credentials
  public ActiveLogin:boolean = false;
  public MobileDeviceGuid:string = ""; // "fbeaf255-d3e7-4ec0-a1ff-46491f0021a7"; //"c8d1afd7-6d4d-4c75-833e-18be6a576c04";
  public MobileUserId:number = 0; // 14117; 

  public HealthRiskFlag: boolean = false;

  // remaining fields
  public MobileUserDisplayName:string = ""; //"Pending Name";
  public EmailAddress:string = ""; // "pending@email.com";
  public PhoneNumber:string = ""; //"+123-555-5555";
  public ScopeTypeId:number = 0; 
  public MobileUserPictureId:number = 0;   
  public MobileDeviceId:number = 0;
  public MobileRegistrationId:number = 0;
  public SystemClientAccessFlag:boolean = false; 
  public OrganizationId:number = 0;  
  public OrganizationCode:string = ""; //"ORG_PENDING";
  public OrganizationName:string = ""; //"Pending Organization";
  public OrganizationLatitude:string = "";
  public OrganizationLongitude:string = "";
  public SiteId:number = 0;                       // MobileUserSiteId
  public SiteCode:string = ""; //"SITE_PENDING";
  public SiteName:string = ""; //"Pending Site";
  public SiteLatitude:string = "";
  public SiteLongitude:string = "";
  public DepartmentId:number = 0;                 // MobileUserDepartmentId
  public DepartmentCode:string = ""; //"DEPT_PENDING";
  public DepartmentName:string = ""; //"Pending Department";
  public RoleId:number = 0;  
  public RoleCode:string = ""; //"ROLE_PENDING";
  public RoleName:string = ""; //"Pending Role";
  public LanguageId:number = 1;  
  public LanguageCode:string = "EN"; //"US-EN";
  public LanguageName:string = "English"; //"English";
  public LanguageNativeName:string = "English"; // Francois
  public LanguageRtl:boolean = false;
  public MomentLocale:string = "en";
  public CheckinSiteId:number = 0;  
  public CheckinSiteCode:string = ""; //"CHECKIN_SITE_PENDING";
  public CheckinSiteName:string = ""; //"Pending Checkin Site";
  public CheckinSiteLatitude:string = "";
  public CheckinSiteLongitude:string = "";
  //public MobileUserSiteId:number = 0; 
  //public MobileUserDepartmentId:number = 0; 
  // not necessarily the latest coordinates, but the last that were provided to the server
  public MobileLocationLatitude:string = "";  // the server may provide this for an IP address
  public MobileLocationLongitude:string = "";  // the server may provide this for an IP address

  private ConvertValue:ConvertValue = new ConvertValue();
  private consoleLog:boolean = false;

  // --------------------------------------------------------------
  // ---------------  LOAD OBJECT FUNCTIONS   ---------------------
  // --------------------------------------------------------------
  public SetFromApiResponse(apiResponse)  // data is ApiResponse
  {
    //if (this.consoleLog) 
    if (this.consoleLog) console.log("global.MobileUserProfile.SetFromApiResponse", apiResponse);

    if (apiResponse.Language)
    {
      //if (this.consoleLog) console.log("StoreUserProfileFromDashboardCall - Language", data.Language);
      this.LanguageId = apiResponse.Language.LanguageId;
      this.LanguageCode = apiResponse.Language.LanguageCode;
      this.LanguageName = apiResponse.Language.LanguageName;
    }

    if (apiResponse.SiteLocation)
    {
      //if (this.consoleLog) console.log("StoreUserProfileFromDashboardCall - SiteLocation", data.SiteLocation);
      this.SiteId = apiResponse.SiteLocation.SiteLocationId;
      this.SiteCode = apiResponse.SiteLocation.SiteLocationCode;
      this.SiteName = apiResponse.SiteLocation.SiteLocationName;

      // these are missing right now
      this.SiteLatitude = apiResponse.SiteLocation.GpsLatitudeDecimal;
      this.SiteLongitude = apiResponse.SiteLocation.GpsLongitudeDecimal;
    }

    if (apiResponse.MobileLocation)
    {
      // not necessarily the latest coordinates, but the last that were provided to the server
      this.MobileLocationLatitude = apiResponse.MobileLocation.GpsLatitudeDecimal;
      this.MobileLocationLongitude = apiResponse.MobileLocation.GpsLongitudeDecimal;
    }

    if (apiResponse.Department)
    {
      //if (this.consoleLog) console.log("StoreUserProfileFromDashboardCall - Department", data.Department);
      this.DepartmentId = apiResponse.Department.DepartmentId;
      this.DepartmentCode = apiResponse.Department.DepartmentCode;
      this.DepartmentName = apiResponse.Department.DepartmentName;
    }

    if (apiResponse.Role)
    {
      //if (this.consoleLog) console.log("StoreUserProfileFromDashboardCall - Role", data.Role);
      this.RoleId = apiResponse.Role.RoleId;
      this.RoleCode = apiResponse.Role.RoleCode;
      this.RoleName = apiResponse.Role.RoleName;
    }

    if (apiResponse.UserScope)
    {
      //if (this.consoleLog) console.log("StoreUserProfileFromDashboardCall - UserScope", data.UserScope);
      this.ScopeTypeId = apiResponse.UserScope.ScopeTypeId;
      // this.storage.set('UserScopeDepartmentId', data.UserScope.DepartmentId; // this will be the user's department
    }

    if ((apiResponse.MobileUser) && (apiResponse.MobileUser.MobileUserDisplayName))
    {
      this.consoleLog = true;
      if (this.consoleLog) console.log("StoreUserProfileFromDashboardCall: MobileUser", apiResponse.MobileUser);

      if (this.consoleLog) console.log('app.StoreUserProfileFromDashboardCall: ' 
                  + ' HealthRiskFlag BEFORE:' + this.HealthRiskFlag
                  + ' HealthRiskFlag PENDING:' + apiResponse.MobileUser.HealthRiskFlag);

      if (apiResponse.MobileUser.MobileDeviceId)         this.MobileDeviceId         = this.ConvertValue.ToNumber(apiResponse.MobileUser.MobileDeviceId, this.MobileDeviceId);
      if (apiResponse.MobileUser.MobileUserPictureId)    this.MobileUserPictureId    = this.ConvertValue.ToNumber(apiResponse.MobileUser.MobileUserPictureId, 0);
      if (apiResponse.MobileUser.MobileUserDisplayName)  this.MobileUserDisplayName  = apiResponse.MobileUser.MobileUserDisplayName;
      if (apiResponse.MobileUser.EmailAddress)           this.EmailAddress           = apiResponse.MobileUser.EmailAddress;
      if (apiResponse.MobileUser.PhoneNumber)            this.PhoneNumber            = apiResponse.MobileUser.PhoneNumber;
      if (apiResponse.MobileUser.OrganizationName)       this.OrganizationName       = apiResponse.MobileUser.OrganizationName;
      
      // do NOT use an IF statement around the existence of a value on these
      this.SystemClientAccessFlag = this.ConvertValue.ToBoolean(apiResponse.MobileUser.SystemClientAccessFlag, false);
      this.HealthRiskFlag         = this.ConvertValue.ToBoolean(apiResponse.MobileUser.HealthRiskFlag, false);

      if (this.consoleLog) console.log('app.StoreUserProfileFromDashboardCall: ' 
                  + ' HealthRiskFlag AFTER:' + this.HealthRiskFlag);

      // note this mobileuser field is populating the UserAppConfig rather than MobileUserProfile
      //if (data.MobileUser.DateFormatId)           this.UserAppConfig.DateFormatId               = data.MobileUser.DateFormatId;
    }
  }

  public SetFromStorage(storedObject:any):boolean
  {
    if (this.consoleLog) console.log("global.MobileUserProfile.SetFromStorage", storedObject);

    try
    {
      if (!storedObject) { return false; }

      if (storedObject.ActiveLogin)            this.ActiveLogin             = this.ConvertValue.ToBoolean(storedObject.ActiveLogin, false);
      if (storedObject.MobileUserId)           this.MobileUserId            = this.ConvertValue.ToNumber(storedObject.MobileUserId, 0);
      if (storedObject.MobileDeviceGuid)       this.MobileDeviceGuid        = this.ConvertValue.ToString(storedObject.MobileDeviceGuid, "");
      if (storedObject.HealthRiskFlag)         this.HealthRiskFlag          = this.ConvertValue.ToBoolean(storedObject.HealthRiskFlag, false);
      if (storedObject.MobileUserDisplayName)  this.MobileUserDisplayName   = this.ConvertValue.ToString(storedObject.MobileUserDisplayName, "");
      if (storedObject.EmailAddress)           this.EmailAddress            = this.ConvertValue.ToString(storedObject.EmailAddress, "");
      if (storedObject.PhoneNumber)            this.PhoneNumber             = this.ConvertValue.ToString(storedObject.PhoneNumber, "");
      if (storedObject.ScopeTypeId)            this.ScopeTypeId             = this.ConvertValue.ToNumber(storedObject.ScopeTypeId, 0);
      if (storedObject.MobileUserPictureId)    this.MobileUserPictureId     = this.ConvertValue.ToNumber(storedObject.MobileUserPictureId, 0);
      if (storedObject.MobileDeviceId)         this.MobileDeviceId          = this.ConvertValue.ToNumber(storedObject.MobileDeviceId, 0);
      if (storedObject.MobileRegistrationId)   this.MobileRegistrationId    = this.ConvertValue.ToNumber(storedObject.MobileRegistrationId, 0);
      if (storedObject.SystemClientAccessFlag) this.SystemClientAccessFlag  = this.ConvertValue.ToBoolean(storedObject.SystemClientAccessFlag, false);
      if (storedObject.OrganizationId)         this.OrganizationId          = this.ConvertValue.ToNumber(storedObject.OrganizationId, 0);
      if (storedObject.OrganizationCode)       this.OrganizationCode        = this.ConvertValue.ToString(storedObject.OrganizationCode, "");
      if (storedObject.OrganizationName)       this.OrganizationName        = this.ConvertValue.ToString(storedObject.OrganizationName, "");
      if (storedObject.OrganizationLatitude)   this.OrganizationLatitude    = this.ConvertValue.ToString(storedObject.OrganizationLatitude, "");
      if (storedObject.OrganizationLongitude)  this.OrganizationLongitude   = this.ConvertValue.ToString(storedObject.OrganizationLongitude, "");
      if (storedObject.SiteId)                 this.SiteId                  = this.ConvertValue.ToNumber(storedObject.SiteId, 0);
      if (storedObject.SiteCode)               this.SiteCode                = this.ConvertValue.ToString(storedObject.SiteCode, "");
      if (storedObject.SiteName)               this.SiteName                = this.ConvertValue.ToString(storedObject.SiteName, "");
      if (storedObject.SiteLatitude)           this.SiteLatitude            = this.ConvertValue.ToString(storedObject.SiteLatitude, "");
      if (storedObject.SiteLongitude)          this.SiteLongitude           = this.ConvertValue.ToString(storedObject.SiteLongitude, "");
      if (storedObject.DepartmentId)           this.DepartmentId            = this.ConvertValue.ToNumber(storedObject.DepartmentId, 0);
      if (storedObject.DepartmentCode)         this.DepartmentCode          = this.ConvertValue.ToString(storedObject.DepartmentCode, "");
      if (storedObject.DepartmentName)         this.DepartmentName          = this.ConvertValue.ToString(storedObject.DepartmentName, "");
      if (storedObject.RoleId)                 this.RoleId                  = this.ConvertValue.ToNumber(storedObject.RoleId, 0);
      if (storedObject.RoleCode)               this.RoleCode                = this.ConvertValue.ToString(storedObject.RoleCode, "");
      if (storedObject.RoleName)               this.RoleName                = this.ConvertValue.ToString(storedObject.RoleName, "");
      if (storedObject.LanguageId)             this.LanguageId              = this.ConvertValue.ToNumber(storedObject.LanguageId, 0);
      if (storedObject.LanguageCode)           this.LanguageCode            = this.ConvertValue.ToString(storedObject.LanguageCode, "");
      if (storedObject.LanguageName)           this.LanguageName            = this.ConvertValue.ToString(storedObject.LanguageName, "");
      if (storedObject.LanguageNativeName)     this.LanguageNativeName      = this.ConvertValue.ToString(storedObject.LanguageNativeName, "");
      if (storedObject.LanguageRtl)            this.LanguageRtl             = this.ConvertValue.ToBoolean(storedObject.LanguageRtl, false);
      if (storedObject.CheckinSiteId)          this.CheckinSiteId           = this.ConvertValue.ToNumber(storedObject.CheckinSiteId, 0);
      if (storedObject.CheckinSiteCode)        this.CheckinSiteCode         = this.ConvertValue.ToString(storedObject.CheckinSiteCode, "");
      if (storedObject.CheckinSiteName)        this.CheckinSiteName         = this.ConvertValue.ToString(storedObject.CheckinSiteName, "");
      if (storedObject.CheckinSiteLatitude)    this.CheckinSiteLatitude     = this.ConvertValue.ToString(storedObject.CheckinSiteLatitude, "");
      if (storedObject.CheckinSiteLongitude)   this.CheckinSiteLongitude    = this.ConvertValue.ToString(storedObject.CheckinSiteLongitude, "");
      if (storedObject.MobileLocationLatitude) this.MobileLocationLatitude  = this.ConvertValue.ToString(storedObject.MobileLocationLatitude, "");
      if (storedObject.MobileLocationLongitude) this.MobileLocationLongitude = this.ConvertValue.ToString(storedObject.MobileLocationLongitude, "");
      
      if (this.consoleLog) console.log('global.MobileUserProfile.SetFromStorage: values parsed ok', this);
      return true;  //return value in then.
    }
    catch (error)
    {
      console.error("global.MobileUserProfile.SetFromStorage ERROR", error);
      return false;
    }
  }

  public ClearObject()
  {
    // special identifier fields required for credentials
    this.ActiveLogin = false;
    this.MobileDeviceGuid = ""; // "fbeaf255-d3e7-4ec0-a1ff-46491f0021a7"; //"c8d1afd7-6d4d-4c75-833e-18be6a576c04";
    this.MobileUserId = 0; // 14117; 

    // remaining fields
    this.HealthRiskFlag = false;
    this.MobileUserDisplayName = ""; //"Pending Name";
    this.EmailAddress = ""; // "pending@email.com";
    this.PhoneNumber = ""; //"+123-555-5555";
    this.ScopeTypeId = 0; 
    this.MobileUserPictureId = 0;   
    this.MobileDeviceId = 0;
    this.MobileRegistrationId = 0;
    this.SystemClientAccessFlag = false; 
    this.OrganizationId = 0;  
    this.OrganizationCode = ""; //"ORG_PENDING";
    this.OrganizationName = ""; //"Pending Organization";
    this.OrganizationLatitude = "";
    this.OrganizationLongitude = "";
    this.SiteId = 0;                       // MobileUserSiteId
    this.SiteCode = ""; //"SITE_PENDING";
    this.SiteName = ""; //"Pending Site";
    this.SiteLatitude = "";
    this.SiteLongitude = "";
    this.DepartmentId = 0;                 // MobileUserDepartmentId
    this.DepartmentCode = ""; //"DEPT_PENDING";
    this.DepartmentName = ""; //"Pending Department";
    this.RoleId = 0;  
    this.RoleCode = ""; //"ROLE_PENDING";
    this.RoleName = ""; //"Pending Role";
    this.LanguageId = 0;  
    this.LanguageCode = ""; //"US-EN";
    this.LanguageName = ""; //"English";
    this.CheckinSiteId = 0;  
    this.CheckinSiteCode = ""; //"CHECKIN_SITE_PENDING";
    this.CheckinSiteName = ""; //"Pending Checkin Site";
    this.CheckinSiteLatitude = "";
    this.CheckinSiteLongitude = "";
    //this.MobileUserSiteId = 0; 
    //this.MobileUserDepartmentId = 0; 
    // not necessarily the latest coordinates, but the last that were provided to the server
    this.MobileLocationLatitude = "";  // the server may provide this for an IP address
    this.MobileLocationLongitude = "";  // the server may provide this for an IP address
  }

  public GetObscuredDeviceGuidForDisplay():string
  {
    if (!this.MobileDeviceGuid)
    {
      return "NONE";
    }

    if (this.MobileDeviceGuid.length > 5)
    {
      // first four characters ... four characters from the end
      return this.MobileDeviceGuid.substr(0,4) + "..." + this.MobileDeviceGuid.substr(-4); 
    }
    else
    {
      return this.MobileDeviceGuid;
    }
  }
}

@Injectable()
export class OrganizationHealthRisk 
{
  public HealthRiskMessageDisplayTypeId: number = 0;   // set at the org level
  public HealthRiskMessageTitle: string = "";       // set at the org level
  public HealthRiskMessageText: string = "";        // set at the org level
  public HealthRiskExternalUrl: string = "";        // set at the org level
  public HealthRiskExternalLabel: string = "";        // set at the org level
  public HealthRiskPhoneNumber: string = "";        // set at the org level
  public HealthRiskPhoneLabel: string = "";        // set at the org level
  public HealthRiskEmailAddress: string = "";        // set at the org level
  public HealthRiskEmailLabel: string = "";        // set at the org level

  private ConvertValue:ConvertValue = new ConvertValue();
  private consoleLog:boolean = false;

  // --------------------------------------------------------------
  // ---------------  LOAD OBJECT FUNCTIONS   ---------------------
  // --------------------------------------------------------------
  public SetFromApiResponse(apiResponse: any, HealthRiskFlag: boolean)  // data is ApiResponse
  {
    if (this.consoleLog) console.log("global.OrganizationHealthRisk.SetFromApiResponse", apiResponse);

    if (!apiResponse.OrganizationHealthRisk) 
    {
      if (HealthRiskFlag)
      {
        console.warn("global.OrganizationHealthRisk.SetFromApiResponse: MobileUser has health risk flag set, BUT No Organization Health Risk info found -- only okay if none is configured, but organization should be encouraged to set this up");
      }
      else
      {
        if (this.consoleLog) console.log("global.OrganizationHealthRisk.SetFromApiResponse -- none found, but this is normal when mobile user is not a health risk");
      }
      return; 
    }

    if (this.consoleLog) console.log("global.OrganizationHealthRisk.SetFromApiResponse", apiResponse.OrganizationHealthRisk);

    this.HealthRiskMessageDisplayTypeId = this.ConvertValue.ToNumber(apiResponse.OrganizationHealthRisk.HealthRiskMessageDisplayTypeId, 0);
    this.HealthRiskMessageTitle = this.ConvertValue.ToString(apiResponse.OrganizationHealthRisk.HealthRiskMessageTitle, "");
    this.HealthRiskMessageText = this.ConvertValue.ToString(apiResponse.OrganizationHealthRisk.HealthRiskMessageText, "");
    this.HealthRiskExternalUrl = this.ConvertValue.ToString(apiResponse.OrganizationHealthRisk.HealthRiskExternalUrl, "");
    this.HealthRiskExternalLabel = this.ConvertValue.ToString(apiResponse.OrganizationHealthRisk.HealthRiskExternalLabel, "");
    this.HealthRiskPhoneNumber = this.ConvertValue.ToString(apiResponse.OrganizationHealthRisk.HealthRiskPhoneNumber, "");
    this.HealthRiskPhoneLabel = this.ConvertValue.ToString(apiResponse.OrganizationHealthRisk.HealthRiskPhoneLabel, "");
    this.HealthRiskEmailAddress = this.ConvertValue.ToString(apiResponse.OrganizationHealthRisk.HealthRiskEmailAddress, "");
    this.HealthRiskEmailLabel = this.ConvertValue.ToString(apiResponse.OrganizationHealthRisk.HealthRiskEmailLabel, "");

    // this shouldn't be necessary if the proper details have been provided for the corresponding names
    if (!this.HealthRiskExternalLabel) { this.HealthRiskExternalLabel = this.HealthRiskExternalUrl; }
    if (!this.HealthRiskPhoneLabel) { this.HealthRiskPhoneLabel = this.HealthRiskPhoneNumber; }
    if (!this.HealthRiskEmailLabel) { this.HealthRiskEmailLabel = this.HealthRiskEmailAddress; }

    // TESTING ONLY!!! ================================
    // TESTING ONLY!!! ================================
    /*
    this.HealthRiskMessageDisplayTypeId = 1; // 0=legacy behaviour | 1=autodisplay in footer | 2=toggle display in footer | 3=open new dialog box | 4=Button to URL
    this.HealthRiskMessageTitle = "Important Information";
    this.HealthRiskMessageText = "We received a HEALTH RISK alert on your account, if you answered “YES” to any of the questions in error, please email lupe.dominguez@sausd.us in Risk Management and let us know. If this was NOT an error, you must enter your exposure or symptoms on the FLAIRZ app, BEFORE you report to work, and follow the instructions provided by the FLAIRZ app, email me once this has been completed and I will clear the ALERT on this account. Call Risk Management if you have questions (714) 558-5875";
    this.HealthRiskExternalUrl = "https://www.sausd.us/covidstaff";
    this.HealthRiskExternalLabel = "Company Procedures";
    this.HealthRiskPhoneNumber = "+17145551212";
    this.HealthRiskPhoneLabel = "Call HR";
    this.HealthRiskEmailAddress = "lupe.dominguez@sausd.us";
    this.HealthRiskEmailLabel = "Email HR";
    */
    // TESTING ONLY!!! ================================
    // TESTING ONLY!!! ================================
  }

  public SetFromStorage(storedObject:any):boolean
  {
    if (this.consoleLog) console.log("global.OrganizationHealthRisk.SetFromStorage", storedObject);

    try
    {
      if (!storedObject) { return false; }

      if (storedObject.HealthRiskMessageDisplayTypeId)   this.HealthRiskMessageDisplayTypeId    = this.ConvertValue.ToNumber(storedObject.HealthRiskMessageDisplayTypeId, 0);
      if (storedObject.HealthRiskMessageTitle)           this.HealthRiskMessageTitle            = this.ConvertValue.ToString(storedObject.HealthRiskMessageTitle, "");
      if (storedObject.HealthRiskMessageText)            this.HealthRiskMessageText             = this.ConvertValue.ToString(storedObject.HealthRiskMessageText, "");
      if (storedObject.HealthRiskExternalUrl)            this.HealthRiskExternalUrl             = this.ConvertValue.ToString(storedObject.HealthRiskExternalUrl, "");
      if (storedObject.HealthRiskExternalLabel)          this.HealthRiskExternalLabel           = this.ConvertValue.ToString(storedObject.HealthRiskExternalLabel, "");
      if (storedObject.HealthRiskPhoneNumber)            this.HealthRiskPhoneNumber             = this.ConvertValue.ToString(storedObject.HealthRiskPhoneNumber, "");
      if (storedObject.HealthRiskPhoneLabel)             this.HealthRiskPhoneLabel              = this.ConvertValue.ToString(storedObject.HealthRiskPhoneLabel, "");
      if (storedObject.HealthRiskEmailAddress)           this.HealthRiskEmailAddress            = this.ConvertValue.ToString(storedObject.HealthRiskEmailAddress, "");
      if (storedObject.HealthRiskEmailLabel)             this.HealthRiskEmailLabel              = this.ConvertValue.ToString(storedObject.HealthRiskEmailLabel, "");
      
      if (this.consoleLog) console.log('global.OrganizationHealthRisk.SetFromStorage: values parsed ok', this);
      return true;  //return value in then.
    }
    catch (error)
    {
      console.error("global.OrganizationHealthRisk.SetFromStorage ERROR", error);
      return false;
    }
  }

  public ClearObject()
  {
    this.HealthRiskMessageDisplayTypeId = 0;   // set at the org level
    this.HealthRiskMessageTitle = "";       // set at the org level
    this.HealthRiskMessageText = "";        // set at the org level
    this.HealthRiskExternalUrl = "";        // set at the org level
    this.HealthRiskExternalLabel = "";        // set at the org level
    this.HealthRiskPhoneNumber = "";        // set at the org level
    this.HealthRiskPhoneLabel = "";        // set at the org level
    this.HealthRiskEmailAddress = "";        // set at the org level
    this.HealthRiskEmailLabel = "";        // set at the org level
  }
}

@Injectable()
export class AmbitConfig 
{
  // Ambit Panic Button -- or -- Panic App settings (determined by isPanicApp)
  public PanicModeOnlyFlag:boolean = false;        // set at MOBILE USER level in the SC Registration page
  public PanicShowStartButtonFlag:boolean = true;  // set at ORG level in the SC Organization page
  public PanicConfirmationType:string = "NONE";    // set at ORG level in the SC Organization page
  public PanicDelayCountdownSeconds:number = 10;   // set at ORG level in the SC Organization page

  public MonitorMustUsePanicFlowFlag: boolean = false; // set at ORG level in a future update to SC Org Page
  public MonitorWarnDisplayFlag: boolean = false;      // set at ORG level in a future update to SC Org Page

  public EnableMetricsFlag:boolean  = false;
  
  // force geofence restriction on actions
  public GeofenceSurveyResponseFlag = false;
  public GeofenceMonitorFlag = false;
  public GeofenceReportFlag = false;
  public GeofenceSupportFlag = false;
  public GeofenceCheckinFlag = false;
  public GeofenceAccessFlag = false;
  public GeofenceDoorControlFlag = false;
  public GeofencePulseFlag = false;
  public GeofenceEvisitorFlag = false;
  public GeofenceConfidenceFlag = false;
  public GeofenceInForceSomewhere = false;

  // isOrganizationIpsEnabled
  public EnableIndoorFlag:boolean = false;  // this is set manually at the Organization level (temp set to true for testing)
  public CheckinSiteIndoorFlag:boolean = false;  // this is set whenever the user checks in to an Indoor mapped site
  public SurveyBroadcastLicensedFlag:boolean = true;  // to do - set this to false once login screen exists
  public MediaFeatureLicensedFlag:boolean = true;  // to do - set this to false once login screen exists
  public ApiServiceDomainRedirect:string = "";
  //public IsActionsList:boolean = false;
  //public ShowFooterGeoOnAllScreens:boolean = false; // maybe make this configurable in settings
  //public UsePhotoFileForBrowser:boolean = false;   // browser uses file whereas native uses Base64 data
  //public MetricUnitsFlag:boolean = false;

  // app level settings (not known to cloud server yet)
  public AmbitMobileAppVersion:string = "6.6.8000007"; //  "6.4.8000000";  major.minor.nnnnnnn
  public AmbitMobileAppVersionShort:string = "6.6.0"; //  this needs to be in config.xml and AndroidManifest.xml
  public AmbitAndroidVersionCode:string = "8060607";  // this needs to be in config.xml and AndroidManifest.xml
  public ApiVersion:string = "";
  public ApiServiceEnvironment:string = "PROD";
  public InsiteLogo = "assets/imgs/HeyHQ_White-Standard.png"; // insite_white-gray_rgb.png
  
  public Override_1Cors_2NoCors_0Default:number = 0;  //public TestWithCorsFlag:boolean = false;
  public TestWithDebugFlag:boolean = false;
  //public ApiServiceCode:string = "";
  public GoogleMapsHttp = "https";
  public GoogleMapsUrl = "maps.googleapis.com/maps/api/js"; // "maps.google.com/maps/api/js?key=";
  public GoogleMapsApiKey = "AIzaSyBfDFNg2VQMTqfvb7vhZ8WxcENtByPzjSY";

  private ConvertValue:ConvertValue = new ConvertValue();
  consoleLog:boolean = false;
  IsLocalUrl:boolean = false;

  constructor()
  {
    this.IsLocalUrl = document.URL.startsWith('http://localhost') ? true : false;
  }

  public GetGoogleMapsSrc()
  {
    console.log("AmbitConfig.GetGoogleMapsUrlAndKey");
    return this.GoogleMapsHttp + "://" 
        +  this.GoogleMapsUrl 
         + "?key=" + this.GoogleMapsApiKey
        ;
    /*
    if(this.apiKey){
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.apiKey + '&callback=mapInit';
    } else {
        script.src = 'https://maps.googleapis.com/maps/api/js?callback=mapInit';       
    }
    */
  }

  public GetIpsEnabledDisplay(isCordova:boolean):string
  {
    if (this.EnableIndoorFlag === false)
    {
      return "Indoor not enabled for organization";
    }

    if (!isCordova)
    {
      return "Indoor only available in mobile app";
    }

    if (!this.CheckinSiteIndoorFlag)
    {
      return "Indoor not available for checked in site";
    }

    return "Indoor Positioning is enabled";
  }

  public GetInsiteLogo()
  {
    if (this.consoleLog) console.log("AmbitConfig.GetInsiteLogo: " + this.InsiteLogo);
    return this.InsiteLogo;

    /*
    if (this.IsLocalUrl) 
    {
      return this.InsiteLogo;
    }
    return "../" + this.InsiteLogo;
    */
  }

  public GetPanicModeConfigInfo(isPanicApp:boolean):string
  {
    let info:string = "";
    
    if (isPanicApp === true)
    {
      info += "PncApp";
    }
    else
    {
      info += "AmbApp";
      if (this.PanicModeOnlyFlag === true)
      {
        info += "Pnc";
      }
    }

    this.PanicShowStartButtonFlag? info += "-Btn1" : info += "-Btn0";

    if (this.PanicConfirmationType === "COUNTDOWN")
    {
      info += "-C" + this.PanicDelayCountdownSeconds;
    }
    else if (this.PanicConfirmationType === "MANUAL")
    {
      info += "-M";
    }
    else if (this.PanicConfirmationType === "NONE")
    {
      info += "-N";
    }
    else
    {
      info += "-x";
    }

    return info;
  }

  public IsShowPanicConfirmation():boolean
  {
    
    if (this.PanicConfirmationType === "COUNTDOWN")
    {
      return true;
    }

    if (this.PanicConfirmationType === "MANUAL")
    {
      return true;
    }

    return false;
  }

  public SetSurveyBroadcastLicensedFlag(SurveyBroadcastLicensedFlag)
  {
    this.SurveyBroadcastLicensedFlag = SurveyBroadcastLicensedFlag;
  }

  public SetMediaFeatureLicensedFlag(MediaFeatureLicensedFlag:boolean)
  {
    this.MediaFeatureLicensedFlag = MediaFeatureLicensedFlag;
  }

  public SetCheckinSiteIndoorFlag(CheckinSiteIndoorFlag:boolean)
  {
    this.CheckinSiteIndoorFlag = CheckinSiteIndoorFlag;
  }

  public SetFromApiResponse(apiResponse):boolean  // data is ApiResponse
  {
    if (this.consoleLog) console.log("global.AmbitConfig.SetFromApiResponse", apiResponse);

    // --------------------------------------------------------
    // -- API SERVER:   store any environment data
    // --------------------------------------------------------
    try
    {
      if (   (apiResponse.ApiReturn) 
          && (apiResponse.ApiReturn.ApiServiceDomainRedirect) 
          && (apiResponse.ApiReturn.ApiServiceDomainRedirect !== "") )
      {
          this.ApiServiceDomainRedirect = apiResponse.AmbitConfig.ApiServiceDomainRedirect;
      }
      else
      {
          this.ApiServiceDomainRedirect = "";
      }

      if (   (apiResponse.ApiReturn) 
          && (apiResponse.ApiReturn.ApiVersion) 
          && (apiResponse.ApiReturn.ApiVersion !== "") )
      {
          this.ApiVersion = apiResponse.ApiReturn.ApiVersion;
      }

      // --------------------------------------------------------
      // -- INDOOR POSITIONING:  store any IPS data
      // --------------------------------------------------------
      if (apiResponse.AmbitConfig)
      {
        // set via call to Dashboard
        this.EnableIndoorFlag = this.ConvertValue.ToBoolean(apiResponse.AmbitConfig.EnableIndoorFlag, false);
      }


      // --------------------------------------------------------
      // -- PANIC MODE:  store any panic mode related data
      // --------------------------------------------------------
      if (apiResponse.AmbitConfig)
      {
        if (this.consoleLog) console.log("global.AmbitConfig.SetFromApiResponse", apiResponse.AmbitConfig);
      
        // set via call to Dashboard
        this.PanicShowStartButtonFlag = this.ConvertValue.ToBoolean(apiResponse.AmbitConfig.PanicShowStartButtonFlag, true);
        this.PanicModeOnlyFlag = this.ConvertValue.ToBoolean(apiResponse.AmbitConfig.PanicModeOnlyFlag, false);
        this.PanicConfirmationType = this.ConvertValue.ToString(apiResponse.AmbitConfig.PanicConfirmationType, "NONE");
        this.PanicDelayCountdownSeconds = this.ConvertValue.ToNumber(apiResponse.AmbitConfig.PanicDelayCountdownSeconds, 10);
      
        // mobile monitor configuration
        this.MonitorMustUsePanicFlowFlag = this.ConvertValue.ToBoolean(apiResponse.AmbitConfig.MonitorMustUsePanicFlowFlag, false);
        this.MonitorWarnDisplayFlag = this.ConvertValue.ToBoolean(apiResponse.AmbitConfig.MonitorWarnDisplayFlag, false);
        
        // metrics related -- determined by organization
        this.EnableMetricsFlag = this.ConvertValue.ToBoolean(apiResponse.AmbitConfig.EnableMetricsFlag, false);

        // force geofence restriction on actions
        this.GeofenceSurveyResponseFlag = this.ConvertValue.ToBoolean(apiResponse.AmbitConfig.GeofenceSurveyResponseFlag, false);
        this.GeofenceMonitorFlag = this.ConvertValue.ToBoolean(apiResponse.AmbitConfig.GeofenceMonitorFlag, false);
        this.GeofenceReportFlag = this.ConvertValue.ToBoolean(apiResponse.AmbitConfig.GeofenceReportFlag, false);
        this.GeofenceSupportFlag = this.ConvertValue.ToBoolean(apiResponse.AmbitConfig.GeofenceSupportFlag, false);
        this.GeofenceCheckinFlag = this.ConvertValue.ToBoolean(apiResponse.AmbitConfig.GeofenceCheckinFlag, false);
        this.GeofenceAccessFlag = this.ConvertValue.ToBoolean(apiResponse.AmbitConfig.GeofenceAccessFlag, false);
        this.GeofenceDoorControlFlag = this.ConvertValue.ToBoolean(apiResponse.AmbitConfig.GeofenceDoorControlFlag, false);
        this.GeofencePulseFlag = this.ConvertValue.ToBoolean(apiResponse.AmbitConfig.GeofencePulseFlag, false);
        this.GeofenceEvisitorFlag = this.ConvertValue.ToBoolean(apiResponse.AmbitConfig.GeofenceEvisitorFlag, false);
        this.GeofenceConfidenceFlag = this.ConvertValue.ToBoolean(apiResponse.AmbitConfig.GeofenceConfidenceFlag, false);
        
        if (   (this.GeofenceSurveyResponseFlag)
            || (this.GeofenceMonitorFlag)
            || (this.GeofenceReportFlag)
            || (this.GeofenceSupportFlag)
            || (this.GeofenceCheckinFlag)
            || (this.GeofenceAccessFlag)
            || (this.GeofenceDoorControlFlag)
            || (this.GeofencePulseFlag)
            || (this.GeofenceEvisitorFlag)
            || (this.GeofenceConfidenceFlag)
        )
        {
          this.GeofenceInForceSomewhere = true;
        }
        else
        {
          this.GeofenceInForceSomewhere = false;
        }

        // geofence site information is in the SiteProximity class
      }

      if (this.consoleLog) console.log("AmbitConfig PanicShowStartButtonFlag:" + this.PanicShowStartButtonFlag);
      if (this.consoleLog) console.log("AmbitConfig PanicModeOnlyFlag:" + this.PanicModeOnlyFlag);
      if (this.consoleLog) console.log("AmbitConfig PanicConfirmationType:" + this.PanicConfirmationType);
      if (this.consoleLog) console.log("AmbitConfig PanicDelayCountdownSeconds:" + this.PanicDelayCountdownSeconds);

      if (this.consoleLog) console.log("AmbitConfig MonitorMustUsePanicFlowFlag:" + this.MonitorMustUsePanicFlowFlag);
      if (this.consoleLog) console.log("AmbitConfig MonitorWarnDisplayFlag:" + this.MonitorWarnDisplayFlag);
      if (this.consoleLog) console.log("AmbitConfig EnableMetricsFlag:" + this.EnableMetricsFlag);

      if (this.consoleLog) console.log("AmbitConfig GeofenceSurveyResponseFlag:" + this.GeofenceSurveyResponseFlag);
      if (this.consoleLog) console.log("AmbitConfig GeofenceMonitorFlag:" + this.GeofenceMonitorFlag);
      if (this.consoleLog) console.log("AmbitConfig GeofenceReportFlag:" + this.GeofenceReportFlag);
      if (this.consoleLog) console.log("AmbitConfig GeofenceSupportFlag:" + this.GeofenceSupportFlag);
      if (this.consoleLog) console.log("AmbitConfig GeofenceCheckinFlag:" + this.GeofenceCheckinFlag);
      if (this.consoleLog) console.log("AmbitConfig GeofenceAccessFlag:" + this.GeofenceAccessFlag);
      if (this.consoleLog) console.log("AmbitConfig GeofenceDoorControlFlag:" + this.GeofenceDoorControlFlag);
      if (this.consoleLog) console.log("AmbitConfig GeofencePulseFlag:" + this.GeofencePulseFlag);
      if (this.consoleLog) console.log("AmbitConfig GeofenceEvisitorFlag:" + this.GeofenceEvisitorFlag);
      if (this.consoleLog) console.log("AmbitConfig GeofenceConfidenceFlag:" + this.GeofenceConfidenceFlag);

      /* NOTE: that the server API determines which DB fields to use based on the App Type (Panic or Ambit)
      public PanicAmbitStartButtonFlag:boolean = true;    // set at ORG level in the SC Organization page
      public PanicAmbitConfirmationType:string = "NONE";  // set at ORG level in the SC Organization page
      
      // panic app settings
      public PanicAppStartButtonFlag:boolean = true;      // set at ORG level in the SC Organization page
      public PanicAppConfirmationType:string = "NONE";    // set at ORG level in the SC Organization page
      
      // panic setttings (for both Panic App and Ambit App)
      public PanicDelayCountdownSeconds:number = 10;   // set at ORG level in the SC Organization page
      */

      return true;
    }
    catch (error)
    {
      console.error("global.AmbitConfig.SetApiService - exception", error);
      //alert("SetApiService error: " + error);
      return false;
    }
  }

  public SetFromStorage(storedObject:any):boolean
  {
    if (this.consoleLog) console.log("global.AmbitConfig.SetFromStorage", storedObject);

    try
    {
      if (!storedObject) { return false; }

      if (storedObject.EnableIndoorFlag)             this.EnableIndoorFlag            = this.ConvertValue.ToBoolean(storedObject.EnableIndoorFlag, false);
      if (storedObject.CheckinSiteIndoorFlag)        this.CheckinSiteIndoorFlag       = this.ConvertValue.ToBoolean(storedObject.CheckinSiteIndoorFlag, false);
      
      if (storedObject.PanicModeOnlyFlag)            this.PanicModeOnlyFlag           = this.ConvertValue.ToBoolean(storedObject.PanicModeOnlyFlag, false);
      if (storedObject.PanicShowStartButtonFlag)     this.PanicShowStartButtonFlag    = this.ConvertValue.ToBoolean(storedObject.PanicShowStartButtonFlag, true);
      if (storedObject.PanicConfirmationType)        this.PanicConfirmationType       = this.ConvertValue.ToString(storedObject.PanicConfirmationType, "NONE");
      if (storedObject.PanicDelayCountdownSeconds)   this.PanicDelayCountdownSeconds  = this.ConvertValue.ToNumber(storedObject.PanicDelayCountdownSeconds, 10);
      
      if (storedObject.MonitorMustUsePanicFlowFlag)  this.MonitorMustUsePanicFlowFlag = this.ConvertValue.ToBoolean(storedObject.MonitorMustUsePanicFlowFlag, true);
      if (storedObject.MonitorWarnDisplayFlag)       this.MonitorWarnDisplayFlag      = this.ConvertValue.ToBoolean(storedObject.MonitorWarnDisplayFlag, true);
      
      if (storedObject.EnableMetricsFlag)            this.EnableMetricsFlag           = this.ConvertValue.ToBoolean(storedObject.EnableMetricsFlag, false);
      
      if (storedObject.GeofenceSurveyResponseFlag)   this.GeofenceSurveyResponseFlag  = this.ConvertValue.ToBoolean(storedObject.GeofenceSurveyResponseFlag, false);
      if (storedObject.GeofenceMonitorFlag)          this.GeofenceMonitorFlag         = this.ConvertValue.ToBoolean(storedObject.GeofenceMonitorFlag, false);
      if (storedObject.GeofenceReportFlag)           this.GeofenceReportFlag          = this.ConvertValue.ToBoolean(storedObject.GeofenceReportFlag, false);
      if (storedObject.GeofenceSupportFlag)          this.GeofenceSupportFlag         = this.ConvertValue.ToBoolean(storedObject.GeofenceSupportFlag, false);
      if (storedObject.GeofenceCheckinFlag)          this.GeofenceCheckinFlag         = this.ConvertValue.ToBoolean(storedObject.GeofenceCheckinFlag, false);
      if (storedObject.GeofenceAccessFlag)           this.GeofenceAccessFlag          = this.ConvertValue.ToBoolean(storedObject.GeofenceAccessFlag, false);
      if (storedObject.GeofenceDoorControlFlag)      this.GeofenceDoorControlFlag     = this.ConvertValue.ToBoolean(storedObject.GeofenceDoorControlFlag, false);
      if (storedObject.GeofencePulseFlag)            this.GeofencePulseFlag           = this.ConvertValue.ToBoolean(storedObject.GeofencePulseFlag, false);
      if (storedObject.GeofenceEvisitorFlag)         this.GeofenceEvisitorFlag        = this.ConvertValue.ToBoolean(storedObject.GeofenceEvisitorFlag, false);
      if (storedObject.GeofenceConfidenceFlag)       this.GeofenceConfidenceFlag      = this.ConvertValue.ToBoolean(storedObject.GeofenceConfidenceFlag, false);
      
      if (storedObject.SurveyBroadcastLicensedFlag)  this.SurveyBroadcastLicensedFlag = this.ConvertValue.ToBoolean(storedObject.SurveyBroadcastLicensedFlag, false);
      if (storedObject.MediaFeatureLicensedFlag)     this.MediaFeatureLicensedFlag    = this.ConvertValue.ToBoolean(storedObject.MediaFeatureLicensedFlag, false);
      //if (storedObject.ApiServiceDomainRedirect)     this.ApiServiceDomainRedirect    = this.ConvertValue.ToString(storedObject.ApiServiceDomainRedirect, "");
      //if (storedObject.AmbitMobileAppVersion)        this.AmbitMobileAppVersion       = this.ConvertValue.ToString(storedObject.AmbitMobileAppVersion, "5.15.2001200");
      //if (storedObject.ApiServiceEnvironment)        this.ApiServiceEnvironment       = this.ConvertValue.ToString(storedObject.ApiServiceEnvironment, "TEST");
      if (storedObject.InsiteLogo)                    this.InsiteLogo                   = this.ConvertValue.ToString(storedObject.InsiteLogo, "assets/imgs/HeyHQ_White-Standard.png"); // insite_white-gray_rgb.png
      
      if (this.consoleLog) console.log('global.AmbitConfig.SetFromStorage: values parsed ok', this);
      return true;  //return value in then.
    }
    catch (error)
    {
      console.error("global.AmbitConfig.SetFromStorage ERROR", error);
      return false;
    }
  }
}

@Injectable()
export class Language 
{
  public LanguageId:number = 1;  
  public LanguageCode:string = "en-US"; //"US-EN";
  public LanguageName:string = "US English"; //"English";
  public LanguageRtl:boolean = false;
  public MomentLocale:string = "en";
  public LanguageData:any = {};
  public isApiLanguageAvailable:boolean = false; // true once we load from an API
  public isNewLanguage:boolean = false;  // true when a new version of the language is available
  public ServerRefreshDatetimeUtc:string = ""; // no need to save this date in storage (might as well force another date read)
  public ServerRefreshDatetime:string = "";

  private ConvertValue:ConvertValue = new ConvertValue();
  consoleLog:boolean = false;

  public SetLanguageData(LanguageId:number, LanguageCode:string, LanguageName:string, LanguageRtl:boolean,
                        MomentLocale:string, newLanguageData:any)
  {
      if (!newLanguageData)
      {
        if (this.consoleLog) console.log("global.LanguageData.SetFromApiResponse - no new language data available");
        this.isNewLanguage = false;
      }
      else
      {
        if (this.consoleLog) console.log("global.LanguageData.SetFromApiResponse - NEW LANGUAGE DATA", newLanguageData);
        // update the language data if any was returned -- otherwise leave what we had before
        // the parent caller will take care of setting the new translation file with this data
        this.LanguageData = newLanguageData;
        this.isApiLanguageAvailable = true;
        this.isNewLanguage = true;

        this.LanguageId = LanguageId;
        this.LanguageCode = LanguageCode;
        this.LanguageName = LanguageName;
        this.LanguageRtl = LanguageRtl;
        this.MomentLocale = MomentLocale;

        // use these dates later to determine if there are any new language data to be refreshed
        this.ServerRefreshDatetimeUtc = moment().utc().format('YYYY-MM-DD HH:mm:ss');
        this.ServerRefreshDatetime = moment().format('YYYY-MM-DD HH:mm:ss');
      }

      return this.isNewLanguage;
  }

  public SetFromStorage(storedObject:any):boolean
  {
    if (this.consoleLog) console.log("global.LanguageData.SetFromStorage", storedObject);

    try
    {
      if (!storedObject) { return false; }

      if (storedObject.isApiLanguageAvailable) this.isApiLanguageAvailable     = this.ConvertValue.ToBoolean(storedObject.isApiLanguageAvailable, false);
      if (storedObject.LanguageData)           this.LanguageData            = this.ConvertValue.ToString(storedObject.LanguageData, "");
      
      if (this.consoleLog) console.log('global.LanguageData.SetFromStorage: values parsed ok', this);
      return true;  //return value in then.
    }
    catch (error)
    {
      console.error("global.LanguageData.SetFromStorage ERROR", error);
      return false;
    }
  }
}

@Injectable()
export class UserAppConfig 
{
  public IsActionsList:boolean = false;
  public ShowFooterGeoOnAllScreens:boolean = false; // maybe make this configurable in settings
  public UsePhotoFileForBrowser:boolean = false;   // browser uses file whereas native uses Base64 data
  public MetricUnitsFlag:boolean = false;
  public DateFormatId:number = 1;
  //public AutoSelectOffSite:boolean = false;     // cannot be true when AutoSelectEventSite is true
  //public AutoSelectOnSite:boolean = false;     // cannot be true when AutoSelectEventSite is true
  public AutoSelectEventSite:boolean = true;  // cannot be true when AutoSelectOffSite is true
  public DefaultPageName:string = "ActionsPage"; // "ActionsPage";  // default page once we've logged in or gone from Splash
  public ThemeCode:string = 'INSITE'; // Constants.THEME_BACKGROUND_INSITE; // 'AMBIT';
  public ThemeButtonClass:string = 'INSITE'; // Constants.THEME_BACKGROUND_INSITE; // 'AMBIT';

  private ConvertValue:ConvertValue = new ConvertValue();
  consoleLog:boolean = false;

  constructor()
  {
    // this.EnsureConsistentAutoSiteConfig();
  }

  //public SetAutoSelectSite(AutoSelectOffSite:boolean, AutoSelectOnSite:boolean, AutoSelectEventSite:boolean)
  public SetAutoSelectSite(AutoSelectEventSite:boolean)
  {
    //this.AutoSelectOffSite = AutoSelectOffSite;
    //this.AutoSelectOnSite = AutoSelectOnSite;
    this.AutoSelectEventSite = AutoSelectEventSite;

    // this.EnsureConsistentAutoSiteConfig();
  }
  
  public SetFromStorage(storedObject:any):boolean
  {
    if (this.consoleLog) console.log("global.UserAppConfig.SetFromStorage", storedObject);

    try
    {
      if (!storedObject) { return false; }

      if (storedObject.IsActionsList)              this.IsActionsList             = this.ConvertValue.ToBoolean(storedObject.IsActionsList, false);
      if (storedObject.ShowFooterGeoOnAllScreens)  this.ShowFooterGeoOnAllScreens = this.ConvertValue.ToBoolean(storedObject.ShowFooterGeoOnAllScreens, false);
      if (storedObject.UsePhotoFileForBrowser)     this.UsePhotoFileForBrowser    = this.ConvertValue.ToBoolean(storedObject.UsePhotoFileForBrowser, false);
      if (storedObject.MetricUnitsFlag)            this.MetricUnitsFlag           = this.ConvertValue.ToBoolean(storedObject.MetricUnitsFlag, false);
      if (storedObject.DateFormatId)               this.DateFormatId              = this.ConvertValue.ToNumber(storedObject.DateFormatId, 1);
      //if (storedObject.AutoSelectOffSite)          this.AutoSelectOffSite         = this.ConvertValue.ToBoolean(storedObject.AutoSelectOffSite, false);
      //if (storedObject.AutoSelectOnSite)           this.AutoSelectOnSite          = this.ConvertValue.ToBoolean(storedObject.AutoSelectOnSite, false);
      if (storedObject.AutoSelectEventSite)      this.AutoSelectEventSite     = this.ConvertValue.ToBoolean(storedObject.AutoSelectEventSite, false);
      if (storedObject.DefaultPageName)            this.DefaultPageName           = this.ConvertValue.ToString(storedObject.DefaultPageName, "ActionsPage");
      if (storedObject.ThemeCode)                  this.ThemeCode                 = this.ConvertValue.ToString(storedObject.ThemeCode, "AMBIT");
      if (storedObject.ThemeButtonClass)           this.ThemeButtonClass          = this.ConvertValue.ToString(storedObject.ThemeButtonClass, "AMBIT");
      
      //this.EnsureConsistentAutoSiteConfig();

      if (this.consoleLog) console.log('global.UserAppConfig.SetFromStorage: values parsed ok', this);
      return true;  //return value in then.
    }
    catch (error)
    {
      console.error("global.UserAppConfig.SetFromStorage ERROR", error);
      return false;
    }
  }

  /*
  EnsureConsistentAutoSiteConfig()
  {
    // hacky code -- combbine these flags into one setting later
    if (this.AutoSelectOffSite === true)
    {
      this.AutoSelectOnSite = false;
      this.AutoSelectEventSite = false;
      return;
    }
    if (this.AutoSelectOnSite === true)
    {
      this.AutoSelectOffSite = false;
      this.AutoSelectEventSite = false;
      return;
    }
    if (this.AutoSelectEventSite === true)
    {
      this.AutoSelectOffSite = false;
      this.AutoSelectOnSite = false;
      return;
    }
    // at least one must be true
    this.AutoSelectOffSite = true;
  }
  */
}

@Injectable()
export class PushConfig 
{
  public AmbitPushRegistrationFlag:boolean = false;
  public AmbitPushRegistrationStatus:string = "";
  public AmbitPushRegistrationDatetime:string = "";
  public DevicePushRegId:string = "";  // PushUrl
  public DevicePushRegType:string = ""; // PushType
  public LatestNotificationTypeCode:string = "";
  public LatestNotificationStatus:string = "";
  public LatestNotificationEventId:number = 0;
  public LatestNotificationDatetime:string = "";
  
  private ConvertValue:ConvertValue = new ConvertValue();
  consoleLog:boolean = false;

  // SetFromApiResponse -- none

  public IsRegisteredWithAmbit():boolean
  {
    if (!this.AmbitPushRegistrationFlag)
    {
      return false;
    }
    if (!this.DevicePushRegId)
    {
      return false;
    }
    return true;
  }

  public GetObscuredPushRegIdForDisplay():string
  {
    if (!this.DevicePushRegId)
    {
      return "NONE";
    }

    if (this.DevicePushRegId.length > 5)
    {
      // first four characters ... four characters from the end
      return this.DevicePushRegId.substr(0,4) + "..." + this.DevicePushRegId.substr(-4); 
    }
    else
    {
      return this.DevicePushRegId;
    }
  }

  public GetAmbitPushRegistrationFlagForDisplay():string
  {
    if (this.AmbitPushRegistrationFlag === true)
    {
      return "Registered";
    }
    else
    {
      return "Not registered";
    }
  }

  public SetDevice(DevicePushRegType:string, DevicePushRegId:string)
  {
    // if we havent registered this push token yet, then indicate that in the status
    if ((this.DevicePushRegId !== DevicePushRegId) || (this.AmbitPushRegistrationFlag === false))
    {
      this.SetRegistration(false, "Pending registration with InSite");
    }

    this.DevicePushRegId = DevicePushRegId;
    this.DevicePushRegType = DevicePushRegType;
  }

  public SetRegistration(AmbitPushRegistrationFlag:boolean, AmbitPushRegistrationStatus:string)
  {
    this.AmbitPushRegistrationFlag = AmbitPushRegistrationFlag;
    this.AmbitPushRegistrationStatus = AmbitPushRegistrationStatus;
    this.AmbitPushRegistrationDatetime = moment().format('YYYY-MM-DD HH:mm:ss');
  }

  public SetLatestReceived(LatestNotificationTypeCode:string, LatestNotificationStatus:string, LatestNotificationEventId:number)
  {
    this.LatestNotificationTypeCode = LatestNotificationTypeCode;
    this.LatestNotificationStatus = LatestNotificationStatus;
    this.LatestNotificationEventId = LatestNotificationEventId;
    this.LatestNotificationDatetime = moment().format('YYYY-MM-DD HH:mm:ss');
  }
  
  public SetFromStorage(storedObject:any):boolean
  {
    if (this.consoleLog) console.log("global.PushConfig.SetFromStorage", storedObject);

    try
    {
      if (!storedObject) { return false; }

      if (storedObject.AmbitPushRegistrationFlag)    this.AmbitPushRegistrationFlag     = this.ConvertValue.ToBoolean(storedObject.AmbitPushRegistrationFlag, false);
      if (storedObject.AmbitPushRegistrationStatus)  this.AmbitPushRegistrationStatus   = this.ConvertValue.ToString(storedObject.AmbitPushRegistrationStatus, "");
      if (storedObject.DevicePushRegId)              this.DevicePushRegId               = this.ConvertValue.ToString(storedObject.DevicePushRegId, "");
      if (storedObject.DevicePushRegType)            this.DevicePushRegType             = this.ConvertValue.ToString(storedObject.DevicePushRegType, "");
      
      if (this.consoleLog) console.log('global.PushConfig.SetFromStorage: values parsed ok', this);
      return true;  //return value in then.
    }
    catch (error)
    {
      console.error("global.PushConfig.SetFromStorage ERROR", error);
      return false;
    }
  }
}

@Injectable()
export class HeaderDisplay 
{
  public OnlineStatusFlag:boolean = false;  
  public MonitorStatusFlag:boolean = false; 
  public GpsStatusFlag:boolean = false;  
  public IpsStatusFlag:boolean = false;  
}

@Injectable()
export class MobileEventCounts 
{
  // public ResponseRequiredTotal:number = 0; // ResponseRequiredTotal
  public ResponseRequiredTotal:MobileEventCountsCategory = new MobileEventCountsCategory();
  public SurveyPending:MobileEventCountsCategory = new MobileEventCountsCategory();
  public SurveyResponded:MobileEventCountsCategory = new MobileEventCountsCategory();
  public Attention:MobileEventCountsCategory = new MobileEventCountsCategory();
  public Assigned:MobileEventCountsCategory = new MobileEventCountsCategory();
  public AmbitMessage:MobileEventCountsCategory = new MobileEventCountsCategory();
  public Submitted:MobileEventCountsCategory = new MobileEventCountsCategory();
  public Broadcasted:MobileEventCountsCategory = new MobileEventCountsCategory(); 
  public EventNotification:MobileEventCountsCategory = new MobileEventCountsCategory();

  consoleLog:boolean = false;

  public SetFromApiResponse(data):boolean
  {
    if (this.consoleLog) console.log("global.MobileEventCounts.SetFromApiResponse", data);

    // NOTE:  at the moment this structure ALWAYS exists, but not every function call sets the counts
    //        so we need to ignore all functions *except* those that return counts
    // ToDo:  we should make this based on a push update so we always have the latest without
    //        having to rely on a user going to a specific function / screen

    if (!data) { return false; }
    if (!data.MobileEventCounts) { return false; }

    // NOTE:  we may want to reconsider this conditional statement
    //if (data.ApiReturn.FunctionName !== "GetDashboardStatusForMobile") { return false; }
    // INSTEAD:  have the API return a flag to indicate if the counts were set...

    var UpdateValuesFlag:boolean = this.GetBoolean(data.MobileEventCounts.UpdatedValuesFlag, false);
    if (!UpdateValuesFlag) { return false; }
    if (this.consoleLog) console.log("global.MobileEventCounts.SetFromApiResponse - counts exist", data.MobileEventCounts);

    // NOT BEING USED AT THE MOMENT
    if (data.MobileEventCounts.SurveyPending)
    {
      this.SurveyPending.Total = data.MobileEventCounts.SurveyPending.Total;
      this.SurveyPending.HighPriority = data.MobileEventCounts.SurveyPending.HighPriority;
      this.SurveyPending.LowPriority = data.MobileEventCounts.SurveyPending.LowPriority;
    }
    if (data.MobileEventCounts.SurveyResponded)
    {
      this.SurveyResponded.Total = data.MobileEventCounts.SurveyResponded.Total;
      this.SurveyResponded.HighPriority = data.MobileEventCounts.SurveyResponded.HighPriority;
      this.SurveyResponded.LowPriority = data.MobileEventCounts.SurveyResponded.LowPriority;
    }

    // MAIN RED COUNTS -- THESE ARE THE USER'S RESPONSIBILITY
    if (data.MobileEventCounts.ResponseRequiredTotal)
    {
      // 2020-04-23 using new total provided by API instead of calculating it here
      this.ResponseRequiredTotal.Total = data.MobileEventCounts.ResponseRequiredTotal.Total;
      this.ResponseRequiredTotal.HighPriority = data.MobileEventCounts.ResponseRequiredTotal.HighPriority;
      this.ResponseRequiredTotal.LowPriority = data.MobileEventCounts.ResponseRequiredTotal.LowPriority;
    }
    if (data.MobileEventCounts.Attention)
    {
      // NOTE: this no longer includes the live surveys that have been responded to
      this.Attention.Total = data.MobileEventCounts.Attention.Total;
      this.Attention.HighPriority = data.MobileEventCounts.Attention.HighPriority;
      this.Attention.LowPriority = data.MobileEventCounts.Attention.LowPriority;
    }
    if (data.MobileEventCounts.Assigned)
    {
      this.Assigned.Total = data.MobileEventCounts.Assigned.Total;
      this.Assigned.HighPriority = data.MobileEventCounts.Assigned.HighPriority;
      this.Assigned.LowPriority = data.MobileEventCounts.Assigned.LowPriority;
    }
    if (data.MobileEventCounts.AmbitMessage)
    {
      this.AmbitMessage.Total = data.MobileEventCounts.AmbitMessage.Total;
      this.AmbitMessage.HighPriority = data.MobileEventCounts.AmbitMessage.HighPriority;
      this.AmbitMessage.LowPriority = data.MobileEventCounts.AmbitMessage.LowPriority;
    }

    // YELLOW COUNTS - THESE ARE JUST INFORMATIONAL COUNTS
    if (data.MobileEventCounts.Broadcasted)
    {
      this.Broadcasted.Total = data.MobileEventCounts.Broadcasted.Total;
      this.Broadcasted.HighPriority = data.MobileEventCounts.Broadcasted.HighPriority;
      this.Broadcasted.LowPriority = data.MobileEventCounts.Broadcasted.LowPriority;
    }
    if (data.MobileEventCounts.Submitted)
    {
      this.Submitted.Total = data.MobileEventCounts.Submitted.Total;
      this.Submitted.HighPriority = data.MobileEventCounts.Submitted.HighPriority;
      this.Submitted.LowPriority = data.MobileEventCounts.Submitted.LowPriority;
    }
    if (data.MobileEventCounts.EventNotification)
    {
      this.EventNotification.Total = data.MobileEventCounts.EventNotification.Total;
      this.EventNotification.HighPriority = data.MobileEventCounts.EventNotification.HighPriority;
      this.EventNotification.LowPriority = data.MobileEventCounts.EventNotification.LowPriority;
    }

    // THE TOTAL RED BADGE COUNT!!
    // this.CalculateResponseRequiredTotal(); // NO LONGER NEEDED AS THE BACKEND API CALL HANDLES THIS
    if (this.consoleLog) console.log("global.MobileEventCounts.SetFromApiResponse - ResponseRequiredTotal:" + this.ResponseRequiredTotal.Total, data.MobileEventCounts);

    // TO KEEP THINGS SIMPLE DO THIS PUBLISH IN THE CALLING FUNCTION
    // notify the side menu and top bar that counts need to be updated...
    // - ToDo check whether this is necessary and only do when counts have *changed*
    //console.log("MobileEventCounts.SetFromApiResponse - publish count update");
    //this.events.publish('isMobileEventCounts', { MobileEventCounts: this});

    return true;
    
    /*
      "MobileEventCounts": {
        "SurveyPending": {
          "Total": 18,
          "HighPriority": 3,
          "LowPriority": 15
        },
        "SurveyResponded": {
          "Total": 8,
          "HighPriority": 4,
          "LowPriority": 4
        },
        "Attention": {
          "Total": 26,
          "HighPriority": 7,
          "LowPriority": 19
        },
        "Submitted": {
          "Total": 8,
          "HighPriority": 5,
          "LowPriority": 3
        },
        "Assigned": {
          "Total": 0,
          "HighPriority": 0,
          "LowPriority": 0
        }
    */
  }

  /*
  public CalculateResponseRequiredTotal()
  {
    // THE TOTAL RED BADGE COUNT!!
    this.ResponseRequiredTotal // this.ResponseRequiredTotal.Total
    = this.Attention.Total 
    + this.Assigned.Total
    + this.AmbitMessage.Total
    ;
  }
  */

  GetBoolean(inValue:any, outDefault:boolean):boolean
  {
    try
    {
      if ((typeof inValue === 'undefined')  || (inValue === null) || (inValue === "{}"))
      {
        return outDefault;
      }
      // usually we expect "TRUE" to be the value, 
      // but adding other possibilities without doing all the string toUpper conversion
      let myBool = inValue === true || inValue === "TRUE" || inValue === "true" || inValue === "True";
      return myBool;
    }
    catch (exception)
    {
      //alert("ambit.GetValue - Exception: " + exception + "  (outDefault: " + outDefault + ")");
      return outDefault;
    }
  }

  /* COPY THESE FUNCTIONS TO THE MAIN SERVICE ABOVE SO THAT WE CAN PUBLISH THE UPDATE FROM THERE
  public ChangeCount_AmbitMessage(PriorityFlag:boolean, CountValueChange:number)
  {
    this.AmbitMessage.ChangeCount(PriorityFlag, CountValueChange);
    this.CalculateResponseRequiredTotal();
  }

  public ChangeCount_EventNotification(PriorityFlag:boolean, CountValueChange:number)
  {
    this.EventNotification.ChangeCount(PriorityFlag, CountValueChange);
    this.CalculateResponseRequiredTotal();
  }
  */

  public SetFromStorage(storedMobileEventCounts:any):boolean
  {
    if (this.consoleLog) console.log("global.MobileEventCounts.SetFromStorage", storedMobileEventCounts);

    // ToDo:  -- and do we even care to do this?
    // ToDo:  -- and do we even care to do this?
    // ToDo:  -- and do we even care to do this?
    // ToDo:  -- and do we even care to do this?
    // ToDo:  -- and do we even care to do this?

    return true;
  }
}

@Injectable()
export class MobileEventCountsCategory 
{
  public Total:number = 0;
  public HighPriority:number = 0;
  public LowPriority:number = 0;

  public ChangeCount(PriorityFlag:boolean, CountValueChange:number)
  {
    if (PriorityFlag === true)
    {
      this.HighPriority +=CountValueChange;
    }
    else
    {
      this.LowPriority +=CountValueChange;
    }
    this.Total = this.HighPriority + this.LowPriority;
  }
}

@Injectable()
export class SiteProximity 
{
  public EventSites:any;
  private NearestSite:SiteStructure = new SiteStructure();
  private NearestGeofenceSite:SiteStructure = new SiteStructure();

  private consoleLog:boolean = false;
  
  public SetFromApiResponse(apiResponse):boolean  // data is ApiResponse
  {
    if (this.consoleLog) console.log("global.SiteProximity.SetFromApiResponse", apiResponse);

    try
    {
      if (!apiResponse) { return false; }
      if (apiResponse.SiteProximityList)
      {
        this.EventSites = apiResponse.SiteProximityList;  // not being used at the moment
      }
      // also OffSite is returned and not being set yet -- ToDo?

      if ((!apiResponse.NearestSite) && (!apiResponse.NearestGeofenceSite)) { return false; }

      if (apiResponse.NearestSite)
      {
        this.NearestSite = new SiteStructure();
        this.NearestGeofenceSite = new SiteStructure();
      }

      if ((apiResponse) && (apiResponse.NearestSite) && (apiResponse.NearestSite.SiteId > 0))
      {
        if (this.consoleLog) console.log("SiteProximity.SetFromApiResponse - NearestSite", apiResponse.NearestSite);
      
        // geofence site information is in the SiteProximity class
        this.NearestSite.SiteId = apiResponse.NearestSite.SiteId;
        this.NearestSite.SiteCode = apiResponse.NearestSite.SiteCode;
        this.NearestSite.SiteName = apiResponse.NearestSite.SiteName;

        this.NearestSite.GpsLongitudeDecimal = apiResponse.NearestSite.GpsLongitudeDecimal;
        this.NearestSite.GpsLatitudeDecimal = apiResponse.NearestSite.GpsLatitudeDecimal;
        // this.NearestSite.BoundingSouthLatitude = apiResponse.NearestSite.xxxx;
        // this.NearestSite.BoundingWestLongitude = apiResponse.NearestSite.xxxx;
        // this.NearestSite.BoundingNorthLatitude = apiResponse.NearestSite.xxxx;
        // this.NearestSite.BoundingEastLongitude = apiResponse.NearestSite.xxxx;
        this.NearestSite.FormattedAddress = apiResponse.NearestSite.FormattedAddress;
        // this.NearestSite.Locality = apiResponse.NearestSite.xxxx;
        // this.NearestSite.PostalCode = apiResponse.NearestSite.xxxx;
        // this.NearestSite.CountryRegion = apiResponse.NearestSite.xxxx;
        // this.NearestSite.AdminDistrict = apiResponse.NearestSite.xxxx;
        // this.NearestSite.AdminDistrict2 = apiResponse.NearestSite.xxxx;
        // this.NearestSite.AddressLine = apiResponse.NearestSite.xxxx;
        // this.NearestSite.VerifiedAddressFlag = apiResponse.NearestSite.xxxx;
        this.NearestSite.IndoorFlag = apiResponse.NearestSite.IndoorFlag;

        this.NearestSite.FloorPlanFlag = apiResponse.NearestSite.FloorPlanFlag; 
        this.NearestSite.MultiFloorFlag = apiResponse.NearestSite.MultiFloorFlag;
        // this.NearestSite.MultiFloorLo = apiResponse.NearestSite.xxxx;   
        // this.NearestSite.MultiFloorHi = apiResponse.NearestSite.xxxx;   
        // this.NearestSite.MultiFloorCount = apiResponse.NearestSite.xxxx;

        this.NearestSite.MobileUsersActiveCount = apiResponse.NearestSite.MobileUsersActiveCount;     // 2019-01-08: for mobile survey
          
        // this.NearestSite.ExternalSiteId = apiResponse.NearestSite.xxxx;      // 2019-12-31 SAUSD for Marquee RecipientGroupId
        this.NearestSite.SiteGroupId = apiResponse.NearestSite.SiteGroupId;          // 2019-12-31 SAUSD for multiple Marquee target 
        this.NearestSite.SiteGroupCode = apiResponse.NearestSite.SiteGroupCode;      // 2019-12-31 SAUSD
        this.NearestSite.SiteGroupName = apiResponse.NearestSite.SiteGroupName;      // 2019-12-31 SAUSD

        this.NearestSite.GeofenceRadiusMiles = apiResponse.NearestSite.GeofenceRadiusMiles; // 2019-12-31 SAUSD for restrict Actions to this area
        this.NearestSite.GeofenceRadiusMeters = apiResponse.NearestSite.GeofenceRadiusMeters;    // 2019-12-31 SAUSD for restrict Actions to this area

        this.NearestSite.SiteDistanceMiles = apiResponse.NearestSite.SiteDistanceMiles; // 2017-12-13 -- ***special column handling***
        this.NearestSite.SiteDistanceMeters = apiResponse.NearestSite.SiteDistanceMeters; // 2020-01-14 -- ***special column handling***

        this.NearestSite.IsDistanceWithinGeoFence  = apiResponse.NearestSite.IsDistanceWithinGeoFence; // 2020-01-16 ***special column handling***
      }
      
      if ((apiResponse) && (apiResponse.NearestGeofenceSite) && (apiResponse.NearestGeofenceSite.SiteId > 0))
      {
        if (this.consoleLog) console.log("SiteProximity.SetFromApiResponse - NearestGeofenceSite", apiResponse.NearestGeofenceSite);
      
        // geofence site information is in the SiteProximity class
        this.NearestGeofenceSite.SiteId = apiResponse.NearestSite.SiteId;
        this.NearestGeofenceSite.SiteCode = apiResponse.NearestSite.SiteCode;
        this.NearestGeofenceSite.SiteName = apiResponse.NearestSite.SiteName;

        this.NearestGeofenceSite.GpsLongitudeDecimal = apiResponse.NearestSite.GpsLongitudeDecimal;
        this.NearestGeofenceSite.GpsLatitudeDecimal = apiResponse.NearestSite.GpsLatitudeDecimal;
        // this.NearestGeofenceSite.BoundingSouthLatitude = apiResponse.NearestSite.xxxx;
        // this.NearestGeofenceSite.BoundingWestLongitude = apiResponse.NearestSite.xxxx;
        // this.NearestGeofenceSite.BoundingNorthLatitude = apiResponse.NearestSite.xxxx;
        // this.NearestGeofenceSite.BoundingEastLongitude = apiResponse.NearestSite.xxxx;
        this.NearestGeofenceSite.FormattedAddress = apiResponse.NearestSite.FormattedAddress;
        // this.NearestGeofenceSite.Locality = apiResponse.NearestSite.xxxx;
        // this.NearestGeofenceSite.PostalCode = apiResponse.NearestSite.xxxx;
        // this.NearestGeofenceSite.CountryRegion = apiResponse.NearestSite.xxxx;
        // this.NearestGeofenceSite.AdminDistrict = apiResponse.NearestSite.xxxx;
        // this.NearestGeofenceSite.AdminDistrict2 = apiResponse.NearestSite.xxxx;
        // this.NearestGeofenceSite.AddressLine = apiResponse.NearestSite.xxxx;
        // this.NearestGeofenceSite.VerifiedAddressFlag = apiResponse.NearestSite.xxxx;
        this.NearestGeofenceSite.IndoorFlag = apiResponse.NearestSite.IndoorFlag;

        this.NearestGeofenceSite.FloorPlanFlag = apiResponse.NearestSite.FloorPlanFlag; 
        this.NearestGeofenceSite.MultiFloorFlag = apiResponse.NearestSite.MultiFloorFlag;
        // this.NearestGeofenceSite.MultiFloorLo = apiResponse.NearestSite.xxxx;   
        // this.NearestGeofenceSite.MultiFloorHi = apiResponse.NearestSite.xxxx;   
        // this.NearestGeofenceSite.MultiFloorCount = apiResponse.NearestSite.xxxx;

        this.NearestGeofenceSite.MobileUsersActiveCount = apiResponse.NearestSite.MobileUsersActiveCount;     // 2019-01-08: for mobile survey
          
        // this.NearestGeofenceSite.ExternalSiteId = apiResponse.NearestSite.xxxx;      // 2019-12-31 SAUSD for Marquee RecipientGroupId
        this.NearestGeofenceSite.SiteGroupId = apiResponse.NearestSite.SiteGroupId;          // 2019-12-31 SAUSD for multiple Marquee target 
        this.NearestGeofenceSite.SiteGroupCode = apiResponse.NearestSite.SiteGroupCode;      // 2019-12-31 SAUSD
        this.NearestGeofenceSite.SiteGroupName = apiResponse.NearestSite.SiteGroupName;      // 2019-12-31 SAUSD

        this.NearestGeofenceSite.GeofenceRadiusMiles = apiResponse.NearestSite.GeofenceRadiusMiles; // 2019-12-31 SAUSD for restrict Actions to this area
        this.NearestGeofenceSite.GeofenceRadiusMeters = apiResponse.NearestSite.GeofenceRadiusMeters;    // 2019-12-31 SAUSD for restrict Actions to this area

        this.NearestGeofenceSite.SiteDistanceMiles = apiResponse.NearestSite.SiteDistanceMiles; // 2017-12-13 -- ***special column handling***
        this.NearestGeofenceSite.SiteDistanceMeters = apiResponse.NearestSite.SiteDistanceMeters; // 2020-01-14 -- ***special column handling***

        this.NearestGeofenceSite.IsDistanceWithinGeoFence  = apiResponse.NearestSite.IsDistanceWithinGeoFence; // 2020-01-16 ***special column handling***
      }

      return true;
    }
    catch (error)
    {
      console.error("global.AmbitConfig.SetFromApiResponse - exception", error);
      //alert("SetApiService error: " + error);
      return false;
    }

  }

  // ------------------------------------------------------------------------------------

  public GetNearestGeofenceSite() // MustBeWithinRange <-- this is implied by it being Geofence true
  {
    if (this.consoleLog) console.log("global.SiteProximity.GetNearestGeofenceSite:" + this.NearestGeofenceSite.SiteId, this.NearestGeofenceSite);
    return this.NearestGeofenceSite;
  }
  public GetNearestGeofenceSiteId()
  {
    return this.NearestGeofenceSite.SiteId;
  }
  public IsDistanceWithinGeoFenceRange()
  {
    return this.NearestGeofenceSite.IsDistanceWithinGeoFence;
  }
  public IsMobileUserBeyondGeofenceRange()
  {
    return !this.NearestGeofenceSite.IsDistanceWithinGeoFence;
  }

  public GetNearestSite()
  {
    if (this.consoleLog) console.log("global.SiteProximity.GetNearestSite:" + this.NearestSite.SiteId, this.NearestSite);
    return this.NearestSite;
  }
  public GetNearestSiteId()
  {
    return this.NearestSite.SiteId;
  }
}

@Injectable()
export class Metrics 
{
  private consoleLog:boolean = true;

  // ToDo:  store recent metrics and make them available for the next API call
  //public ApiFunctionId:number = 0;
  //public ApiLogId:number = 0;
  //public ApiMilliseconds:number = 0;
  //public RoundtripMs:number = 0;
  //public NetworkMs:number = 0;

  private PendingCount:number = 0;
  private ApiMetricsQs: string;

  public InitializeMetricsData()
  {
    //this.ApiFunctionId = 0;
    //this.ApiLogId = 0;
    //this.ApiMilliseconds = 0;
    //this.RoundtripMs = 0;
    //this.NetworkMs = 0;
  }

  public SetMetrics(ApiFunctionId, ApiLogId, ApiMilliseconds, RoundtripMs, NetworkMs)
  {
    // Temporary -- this is just a single record 
    // - this willNOT be exhaustive of all calls, and is subject to being overwritten before sending
    // - for now just testing the idea out and to get some stats returned to cloud

    // ToDo: manage these in a list instead?
    //this.ApiFunctionId = ApiFunctionId;
    //this.ApiLogId = ApiLogId;
    //this.ApiMilliseconds = ApiMilliseconds;
    //this.RoundtripMs = RoundtripMs;
    //this.NetworkMs = NetworkMs;

    // ensure a reasonable backlog of metrics
    // - we don't want to impact normal processing
    if (this.PendingCount > 10)
    {
      this.ResetQueryString();
    }

    // append stats to existing metrics (this will appear as an array of comma-delimited metrics on the server)
    this.ApiMetricsQs = this.ApiMetricsQs
        + '&Metrics'
        + '=' + ApiFunctionId
        + '|' + ApiLogId
        + '|' + RoundtripMs
        + '|' + NetworkMs
        + '|' + ApiMilliseconds
        ;
    
    this.PendingCount++;
  }

  public GetQueryString():string
  {
    // typically follow this call with a reset...
    return this.ApiMetricsQs;
  }

  public ResetQueryString()
  {
    this.ApiMetricsQs = '';
    this.PendingCount = 0; 
  }
}

@Injectable()
export class LatestMonitor 
{
  public MobileMonitorId:number = 0;
  public EventId:number = 0;
  public MobileMonitorTypeCode:string = "";
  public isActive:boolean = false;

  private ConvertValue:ConvertValue = new ConvertValue();
  private consoleLog:boolean = false;

  public SetLatestMonitor( CurrentMobileMonitorId:number, CurrentEventId:number
                  , CurrentMobileMonitorTypeCode:string, isActive:boolean):boolean
  {
    // returns true
    if (CurrentMobileMonitorId === 0)
    {
      if (this.consoleLog) console.warn("LatestMonitor.SetLatestMonitor - no data provided" + " - returning " + isActive);
      return isActive; // nothing to check against
    }


    if (this.MobileMonitorId === 0)
    {
      // first time load of monitor info
      if (this.consoleLog) console.log("LatestMonitor.SetLatestMonitor - first time set - MobileMonitorId:" + CurrentMobileMonitorId + " EventId:" + CurrentEventId + " isActive:" +isActive + " - returning " + isActive);
      this.MobileMonitorId = CurrentMobileMonitorId;
      this.EventId = CurrentEventId;
      this.MobileMonitorTypeCode = CurrentMobileMonitorTypeCode;
      this.isActive = isActive;
      return isActive;
    }
    else if (this.MobileMonitorId < CurrentMobileMonitorId)
    {
      // newer monitor information
      if (this.consoleLog) console.log("LatestMonitor.SetLatestMonitor - new latest - MobileMonitorId:" + CurrentMobileMonitorId + " EventId:" + CurrentEventId + " isActive:" + isActive + " - returning " + isActive);
      this.MobileMonitorId = CurrentMobileMonitorId;
      this.EventId = CurrentEventId;
      this.MobileMonitorTypeCode = CurrentMobileMonitorTypeCode;
      this.isActive = isActive;
      return isActive;
    }
    else if (this.MobileMonitorId === CurrentMobileMonitorId)
    {
      // same monitor information as before -- only isActive could have changed (possibly MobileMonitorTypeCode too?) 
      this.MobileMonitorId = CurrentMobileMonitorId;
      this.EventId = CurrentEventId;
      this.MobileMonitorTypeCode = CurrentMobileMonitorTypeCode;
      if ((this.isActive) && (!isActive))
      {
        if (this.consoleLog) console.log("LatestMonitor.SetLatestMonitor - changing from active - MobileMonitorId:" + CurrentMobileMonitorId + " EventId:" + CurrentEventId + " isActive:" +isActive + " - returning false");
        this.isActive = isActive;  // only allow switch from true to false -- but never the other way around
        return false; // isActive;
      }
      else
      {
       if (this.consoleLog) console.log("LatestMonitor.SetLatestMonitor - unchanged status - MobileMonitorId:" + CurrentMobileMonitorId + " EventId:" + CurrentEventId + " isActive:" +isActive + " - returning " + this.isActive);
         return this.isActive; // return the state o
      }
    }
    else // (this.MobileMonitorId > CurrentMobileMonitorId)
    {
      // we are receiving stale data, so just ignore it since we only want the latest
      if (this.consoleLog) console.log("LatestMonitor.SetLatestMonitor - ignore stale data - MobileMonitorId:" + CurrentMobileMonitorId + " EventId:" + CurrentEventId + " isActive:" + isActive + " - returning false");
      return false;
    }
  }

  public IsThisLatestMonitorAndActive(CurrentMobileMonitorId:number, currentIsActive:boolean )
  {
    if (CurrentMobileMonitorId > this.MobileMonitorId)
    {
      return currentIsActive;
    }
    else if (CurrentMobileMonitorId === this.MobileMonitorId)
    {
      if (!this.isActive)
      {
        return false; // if it was previously ended, then that takes precedence
      } 
      else
      {
        return currentIsActive;
      }
    }
    else
    {
      return false;  // either this is not the latest or it was previously ended
    }
  }

  // --------------------------------------------------------------
  // ---------------  LOAD OBJECT FUNCTIONS   ---------------------
  // --------------------------------------------------------------
  
  public SetFromStorage(storedLatestMonitor:any):boolean
  {
    if (this.consoleLog) console.log("global.LatestMonitor.SetFromStorage", storedLatestMonitor);

    try
    {
      if (!storedLatestMonitor) { return false; }

      if (storedLatestMonitor.SurveyBroadcastId)             this.MobileMonitorId       = this.ConvertValue.ToNumber(storedLatestMonitor.MobileMonitorId, 0);
      if (storedLatestMonitor.SurveyRecipientId)             this.EventId               = this.ConvertValue.ToNumber(storedLatestMonitor.EventId, 0);
      if (storedLatestMonitor.SurveyResponseStatusCode)      this.MobileMonitorTypeCode = this.ConvertValue.ToString(storedLatestMonitor.MobileMonitorTypeCode, "");
      if (storedLatestMonitor.isActive)                      this.isActive              = this.ConvertValue.ToBoolean(storedLatestMonitor.isActive, false);
      
      if (this.consoleLog) console.log('global.LatestMonitor.SetFromStorage: values parsed ok', this);
      return true;  //return value in then.
    }
    catch (error)
    {
      console.error("global.LatestMonitor.SetFromStorage ERROR", error);
      return false;
    }
  }
}

@Injectable()
export class LatestSurvey 
{
  public SurveyBroadcastId:number = 0;
  public SurveyRecipientId:number = 0;
  public SurveyResponseStatusCode:string = "";

  private ConvertValue:ConvertValue = new ConvertValue();
  private consoleLog:boolean = false;

  SetLatestSeen(ActiveSurveyBroadcastId:number, ActiveSurveyRecipientId:number, ActiveSurveyResponseStatusCode:string)
  {
    // do NOT call this directly from outside of the global.ts
    // - instead call the parent global level function that invokes this and then saves in storage

    // this is to help us avoid redundantly showing the same push notification alert
    // when the user enters the app directly and we need to know if they have seen the alert previously
    // (as we need to know if they already saw the message by prssing the push alert)

    //if (this.consoleLog) 
    console.log("global.LatestSurvey.SetLatestSeen - check ActiveSurveyBroadcastId:" + ActiveSurveyBroadcastId + " " + ActiveSurveyResponseStatusCode);
  
    // if the latest we have is later than the current passed in value, then nothing to do
    if (this.SurveyBroadcastId >= ActiveSurveyBroadcastId) 
    {
      //if (this.consoleLog) 
      console.log("global.LatestSurvey.SetLatestSeen - nothing to update as stored " + this.SurveyBroadcastId + " >= current " + ActiveSurveyBroadcastId);
      // nothing to update as the currently viewed survey is not the latest
      return;
    }

    // ----------------------------------------------------------------------------
    // at this point we know that we need to store the active as latest 
    // ----------------------------------------------------------------------------

    // (just need to log the appropriate message)
    if (this.SurveyBroadcastId === 0)
    {
      //if (this.consoleLog) 
      console.log("global.LatestSurvey.SetLatestSeen - no previously stored found");
    }
    else
    {
      //if (this.consoleLog) 
      console.log("global.LatestSurvey.SetLatestSeen - store active " + ActiveSurveyBroadcastId + " > previous latest " + this.SurveyBroadcastId);
    }

    this.SurveyBroadcastId = ActiveSurveyBroadcastId;
    this.SurveyRecipientId = ActiveSurveyRecipientId;
    this.SurveyResponseStatusCode = ActiveSurveyResponseStatusCode;
  }

  HasThisSurveyBeenSeenAlready(CheckSurveyBroadcastIdInteger: number):boolean //(SurveyBroadcastId)
  {
    // Check to see if the input SurveyBroadcastId is the latest seen by the user
    if (this.consoleLog) console.log("LatestSurvey.HasThisSurveyBeenSeenAlready - check SurveyBroadcastId:" + CheckSurveyBroadcastIdInteger);

    if (this.SurveyBroadcastId === 0)
    {
      // assume this survey has not been seen yet
      if (this.consoleLog) console.log("LatestSurvey.HasThisSurveyBeenSeenAlready - ASSUME NOT SEEN as no previously stored found");
      //this.SurveyBroadcastId = CheckSurveyBroadcastIdInteger; // do this in the call to this.globalProvider.SetStorageObject_LatestSurvey()
      return false;  // *** SHOW THIS SURVEY ***
    }

    if (this.SurveyBroadcastId < CheckSurveyBroadcastIdInteger) 
    {
      if (this.consoleLog) console.log("LatestSurvey.HasThisSurveyBeenSeenAlready - NOT SEEN YET - last seen " + this.SurveyBroadcastId + " < active " + CheckSurveyBroadcastIdInteger);
      //this.SurveyBroadcastId = CheckSurveyBroadcastIdInteger; // do this in the call to this.globalProvider.SetStorageObject_LatestSurvey()
      return false;  // *** SHOW THIS SURVEY ***
    }

    // at this point we know we are looking at the latest survey
    if (this.SurveyBroadcastId === CheckSurveyBroadcastIdInteger) 
    {
      if (this.consoleLog) console.log("LatestSurvey.HasThisSurveyBeenSeenAlready - ALREADY SEEN - last seen " + this.SurveyBroadcastId + " === active " + CheckSurveyBroadcastIdInteger);
      return true;  // *** do NOT show this survey ***
    }

    // at this point we know we are looking at the latest survey
    if (this.consoleLog) console.log("LatestSurvey.HasThisSurveyBeenSeenAlready - ALREADY SEEN - last seen " + this.SurveyBroadcastId + " > active " + CheckSurveyBroadcastIdInteger);
    return true;  // *** do NOT show this survey ***
  }

  // --------------------------------------------------------------
  // ---------------  LOAD OBJECT FUNCTIONS   ---------------------
  // --------------------------------------------------------------
  public SetFromApiResponse(apiResponse):boolean  // data is ApiResponse
  {
    if (this.consoleLog) console.log("global.LatestSurvey.SetFromApiResponse", apiResponse);

    // ToDo:  -- and do we even care to do this?
    // ToDo:  -- and do we even care to do this?
    // ToDo:  -- and do we even care to do this?
    // ToDo:  -- and do we even care to do this?
    // ToDo:  -- and do we even care to do this?

    return true;
  }

  public SetFromStorage(storedLatestSurvey:any):boolean
  {
    if (this.consoleLog) console.log("global.LatestSurvey.SetFromStorage", storedLatestSurvey);

    try
    {
      if (!storedLatestSurvey) { return false; }

      if (storedLatestSurvey.SurveyBroadcastId)             this.SurveyBroadcastId            = this.ConvertValue.ToNumber(storedLatestSurvey.SurveyBroadcastId, 0);
      if (storedLatestSurvey.SurveyRecipientId)             this.SurveyRecipientId            = this.ConvertValue.ToNumber(storedLatestSurvey.SurveyRecipientId, 0);
      if (storedLatestSurvey.SurveyResponseStatusCode)      this.SurveyResponseStatusCode     = this.ConvertValue.ToString(storedLatestSurvey.SurveyResponseStatusCode, "");
      
      if (this.consoleLog) console.log('global.LatestSurvey.SetFromStorage: values parsed ok', this);
      return true;  //return value in then.
    }
    catch (error)
    {
      console.error("global.LatestSurvey.SetFromStorage ERROR", error);
      return false;
    }
  }
}

@Injectable()
export class LatestActionableForm 
{
  public ActionableBroadcastId:number = 0;
  public ActionableRecipientId:number = 0;
  public ActionableResponseStatusCode:string = "";

  private ConvertValue:ConvertValue = new ConvertValue();
  private consoleLog:boolean = false;

  SetLatestSeen(ActiveActionableBroadcastId:number, ActiveActionableRecipientId:number, ActiveActionableResponseStatusCode:string)
  {
    // do NOT call this directly from outside of the global.ts
    // - instead call the parent global level function that invokes this and then saves in storage

    // this is to help us avoid redundantly showing the same push notification alert
    // when the user enters the app directly and we need to know if they have seen the alert previously
    // (as we need to know if they already saw the message by prssing the push alert)

    //if (this.consoleLog) 
    console.log("global.LatestActionableForm.SetLatestSeen - check ActiveActionableBroadcastId:" + ActiveActionableBroadcastId + " " + ActiveActionableResponseStatusCode);
  
    // if the latest we have is later than the current passed in value, then nothing to do
    if (this.ActionableBroadcastId >= ActiveActionableBroadcastId) 
    {
      //if (this.consoleLog) 
      console.log("global.LatestActionableForm.SetLatestSeen - nothing to update as stored " + this.ActionableBroadcastId + " >= current " + ActiveActionableBroadcastId);
      // nothing to update as the currently viewed actionable form is not the latest
      return;
    }

    // ----------------------------------------------------------------------------
    // at this point we know that we need to store the active as latest 
    // ----------------------------------------------------------------------------

    // (just need to log the appropriate message)
    if (this.ActionableBroadcastId === 0)
    {
      //if (this.consoleLog) 
      console.log("global.LatestActionableForm.SetLatestSeen - no previously stored found");
    }
    else
    {
      //if (this.consoleLog) 
      console.log("global.LatestActionableForm.SetLatestSeen - store active " + ActiveActionableBroadcastId + " > previous latest " + this.ActionableBroadcastId);
    }

    this.ActionableBroadcastId = ActiveActionableBroadcastId;
    this.ActionableRecipientId = ActiveActionableRecipientId;
    this.ActionableResponseStatusCode = ActiveActionableResponseStatusCode;
  }

  HasThisActionableFormBeenSeenAlready(CheckActionableBroadcastIdInteger: number):boolean 
  {
    // Check to see if the input BroadcastId is the latest seen by the user
    if (this.consoleLog) console.log("LatestActionableForm.HasThisActionableFormBeenSeenAlready - check ActionableBroadcastId:" + CheckActionableBroadcastIdInteger);

    if (this.ActionableBroadcastId === 0)
    {
      // assume this survey has not been seen yet
      if (this.consoleLog) console.log("LatestActionableForm.HasThisActionableFormBeenSeenAlready - ASSUME NOT SEEN as no previously stored found");
      //this.SurveyFormBroadcastId = CheckSurveyFormBroadcastIdInteger; // do this in the call to this.globalProvider.SetStorageObject_LatestActionableForm()
      return false;  // *** SHOW THIS ACTIONABLE FORM ***
    }

    if (this.ActionableBroadcastId < CheckActionableBroadcastIdInteger) 
    {
      if (this.consoleLog) console.log("LatestActionableForm.HasThisActionableFormBeenSeenAlready - NOT SEEN YET - last seen " + this.ActionableBroadcastId + " < active " + CheckActionableBroadcastIdInteger);
      //this.SurveyFormBroadcastId = CheckSurveyFormBroadcastIdInteger; // do this in the call to this.globalProvider.SetStorageObject_LatestActionableForm()
      return false;  // *** SHOW THIS ACTIONABLE FORM ***
    }

    // at this point we know we are looking at the latest survey
    if (this.ActionableBroadcastId === CheckActionableBroadcastIdInteger) 
    {
      if (this.consoleLog) console.log("LatestActionableForm.HasThisActionableFormBeenSeenAlready - ALREADY SEEN - last seen " + this.ActionableBroadcastId + " === active " + CheckActionableBroadcastIdInteger);
      return true;  // *** do NOT show this ACTIONABLE FORM ***
    }

    // at this point we know we are looking at the latest survey
    if (this.consoleLog) console.log("LatestActionableForm.HasThisActionableFormBeenSeenAlready - ALREADY SEEN - last seen " + this.ActionableBroadcastId + " > active " + CheckActionableBroadcastIdInteger);
    return true;  // *** do NOT show this ACTIONABLE FORM ***
  }

  // --------------------------------------------------------------
  // ---------------  LOAD OBJECT FUNCTIONS   ---------------------
  // --------------------------------------------------------------
  public SetFromApiResponse(apiResponse):boolean  // data is ApiResponse
  {
    if (this.consoleLog) console.log("global.LatestActionableForm.SetFromApiResponse", apiResponse);

    // ToDo:  -- and do we even care to do this?
    // ToDo:  -- and do we even care to do this?
    // ToDo:  -- and do we even care to do this?
    // ToDo:  -- and do we even care to do this?
    // ToDo:  -- and do we even care to do this?

    return true;
  }

  public SetFromStorage(storedLatestActionableForm:any):boolean
  {
    if (this.consoleLog) console.log("global.LatestActionableForm.SetFromStorage", storedLatestActionableForm);

    try
    {
      if (!storedLatestActionableForm) { return false; }

      if (storedLatestActionableForm.ActionableBroadcastId)             this.ActionableBroadcastId            = this.ConvertValue.ToNumber(storedLatestActionableForm.ActionableBroadcastId, 0);
      if (storedLatestActionableForm.ActionableRecipientId)             this.ActionableRecipientId            = this.ConvertValue.ToNumber(storedLatestActionableForm.ActionableRecipientId, 0);
      if (storedLatestActionableForm.ActionableResponseStatusCode)      this.ActionableResponseStatusCode     = this.ConvertValue.ToString(storedLatestActionableForm.ActionableResponseStatusCode, "");
      
      if (this.consoleLog) console.log('global.LatestActionableForm.SetFromStorage: values parsed ok', this);
      return true;  //return value in then.
    }
    catch (error)
    {
      console.error("global.LatestActionableForm.SetFromStorage ERROR", error);
      return false;
    }
  }
}

@Injectable()
export class LatestEventNotification 
{
  public AmbitMessageId:number = 0;  // later ... EventNotificationId
  public EventId:number = 0;
  public ResponseStatusCode:string = "";

  private ConvertValue:ConvertValue = new ConvertValue();
  private consoleLog:boolean = false;

  SetLatestSeen(ActiveAmbitMessageId:number, ActiveEventId:number, ActiveResponseStatusCode:string)
  {
    // do NOT call this directly from outside of the global.ts
    // - instead call the parent global level function that invokes this and then saves in storage

    // this is to help us avoid redundantly showing the same push notification alert
    // when the user enters the app directly and we need to know if they have seen the alert previously
    // (as we need to know if they already saw the message by prssing the push alert)

    //if (this.consoleLog) 
    console.log("global.LatestEventNotification.SetLatestSeen - check ActiveAmbitMessageId:" + ActiveAmbitMessageId + " " + ActiveResponseStatusCode);
  
    // if the latest we have is later than the current passed in value, then nothing to do
    if (this.AmbitMessageId >= ActiveAmbitMessageId) 
    {
      //if (this.consoleLog) 
      console.log("global.LatestEventNotification.SetLatestSeen - nothing to update as stored " + this.AmbitMessageId + " >= current " + ActiveAmbitMessageId);
      // nothing to update as the currently viewed AMBIT MESSAGE is not the latest
      return;
    }

    // ----------------------------------------------------------------------------
    // at this point we know that we need to store the active as latest 
    // ----------------------------------------------------------------------------

    // (just need to log the appropriate message)
    if (this.AmbitMessageId === 0)
    {
      //if (this.consoleLog) 
      console.log("global.LatestEventNotification.SetLatestSeen - no previously stored found");
    }
    else
    {
      //if (this.consoleLog) 
      console.log("global.LatestEventNotification.SetLatestSeen - store active " + ActiveAmbitMessageId + " > previous latest " + this.AmbitMessageId);
    }

    this.AmbitMessageId = ActiveAmbitMessageId;
    this.EventId = ActiveEventId;
    this.ResponseStatusCode = ActiveResponseStatusCode;
  }

  HasThisEventNotificationBeenSeenAlready(CheckAmbitMessageIdInteger: number):boolean 
  {
    // Check to see if the input AmbitMessageId is the latest seen by the user
    if (this.consoleLog) console.log("LatestEventNotification.HasThisEventNotificationBeenSeenAlready - check AmbitMessageId:" + CheckAmbitMessageIdInteger);

    if (this.AmbitMessageId === 0)
    {
      // assume this AMBIT MESSAGE has not been seen yet
      if (this.consoleLog) console.log("LatestEventNotification.HasThisEventNotificationBeenSeenAlready - ASSUME NOT SEEN as no previously stored found");
      //this.AmbitMessageId = CheckAmbitMessageIdInteger; // do this in the call to this.globalProvider.SetStorageObject_LatestAmbitMessage()
      return false;  // *** SHOW THIS AMBIT MESSAGE ***
    }

    if (this.AmbitMessageId < CheckAmbitMessageIdInteger) 
    {
      if (this.consoleLog) console.log("LatestEventNotification.HasThisEventNotificationBeenSeenAlready - NOT SEEN YET - last seen " + this.AmbitMessageId + " < active " + CheckAmbitMessageIdInteger);
      //this.AmbitMessageId = CheckAmbitMessageIdInteger; // do this in the call to this.globalProvider.SetStorageObject_LatestAmbitMessage()
      return false;  // *** SHOW THIS AMBIT MESSAGE ***
    }

    // at this point we know we are looking at the latest AMBIT MESSAGE
    if (this.AmbitMessageId === CheckAmbitMessageIdInteger) 
    {
      if (this.consoleLog) console.log("LatestEventNotification.HasThisEventNotificationBeenSeenAlready - ALREADY SEEN - last seen " + this.AmbitMessageId + " === active " + CheckAmbitMessageIdInteger);
      return true;  // *** do NOT show this AMBIT MESSAGE ***
    }

    // at this point we know we are looking at the latest AMBIT MESSAGE
    if (this.consoleLog) console.log("LatestEventNotification.HasThisEventNotificationBeenSeenAlready - ALREADY SEEN - last seen " + this.AmbitMessageId + " > active " + CheckAmbitMessageIdInteger);
    return true;  // *** do NOT show this AMBIT MESSAGE ***
  }

  // --------------------------------------------------------------
  // ---------------  LOAD OBJECT FUNCTIONS   ---------------------
  // --------------------------------------------------------------
  public SetFromApiResponse(apiResponse):boolean  // data is ApiResponse
  {
    if (this.consoleLog) console.log("global.LatestEventNotification.SetFromApiResponse", apiResponse);

    // ToDo:  -- and do we even care to do this?
    // ToDo:  -- and do we even care to do this?
    // ToDo:  -- and do we even care to do this?
    // ToDo:  -- and do we even care to do this?
    // ToDo:  -- and do we even care to do this?

    return true;
  }

  public SetFromStorage(storedLatestAmbitMessage:any):boolean
  {
    if (this.consoleLog) console.log("global.LatestEventNotification.SetFromStorage", storedLatestAmbitMessage);

    try
    {
      if (!storedLatestAmbitMessage) { return false; }

      if (storedLatestAmbitMessage.AmbitMessageId)             this.AmbitMessageId            = this.ConvertValue.ToNumber(storedLatestAmbitMessage.AmbitMessageId, 0);
      if (storedLatestAmbitMessage.EventId)             this.EventId            = this.ConvertValue.ToNumber(storedLatestAmbitMessage.EventId, 0);
      if (storedLatestAmbitMessage.ResponseStatusCode)      this.ResponseStatusCode     = this.ConvertValue.ToString(storedLatestAmbitMessage.ResponseStatusCode, "");
      
      if (this.consoleLog) console.log('global.LatestEventNotification.SetFromStorage: values parsed ok', this);
      return true;  //return value in then.
    }
    catch (error)
    {
      console.error("global.LatestEventNotification.SetFromStorage ERROR", error);
      return false;
    }
  }
}

@Injectable()
export class LatestAmbitMessage 
{
  public AmbitMessageId:number = 0;
  public EventId:number = 0;
  public ResponseStatusCode:string = "";

  private ConvertValue:ConvertValue = new ConvertValue();
  private consoleLog:boolean = false;

  SetLatestSeen(ActiveAmbitMessageId:number, ActiveAmbitMessageEventId:number, ActiveAmbitMessageResponseStatusCode:string)
  {
    // do NOT call this directly from outside of the global.ts
    // - instead call the parent global level function that invokes this and then saves in storage

    // this is to help us avoid redundantly showing the same push notification alert
    // when the user enters the app directly and we need to know if they have seen the alert previously
    // (as we need to know if they already saw the message by prssing the push alert)

    //if (this.consoleLog) 
    console.log("global.LatestAmbitMessage.SetLatestSeen - check ActiveAmbitMessageId:" + ActiveAmbitMessageId + " " + ActiveAmbitMessageResponseStatusCode);
  
    // if the latest we have is later than the current passed in value, then nothing to do
    if (this.AmbitMessageId >= ActiveAmbitMessageId) 
    {
      //if (this.consoleLog) 
      console.log("global.LatestAmbitMessage.SetLatestSeen - nothing to update as stored " + this.AmbitMessageId + " >= current " + ActiveAmbitMessageId);
      // nothing to update as the currently viewed AMBIT MESSAGE is not the latest
      return;
    }

    // ----------------------------------------------------------------------------
    // at this point we know that we need to store the active as latest 
    // ----------------------------------------------------------------------------

    // (just need to log the appropriate message)
    if (this.AmbitMessageId === 0)
    {
      //if (this.consoleLog) 
      console.log("global.LatestAmbitMessage.SetLatestSeen - no previously stored found");
    }
    else
    {
      //if (this.consoleLog) 
      console.log("global.LatestAmbitMessage.SetLatestSeen - store active " + ActiveAmbitMessageId + " > previous latest " + this.AmbitMessageId);
    }

    this.AmbitMessageId = ActiveAmbitMessageId;
    this.EventId = ActiveAmbitMessageEventId;
    this.ResponseStatusCode = ActiveAmbitMessageResponseStatusCode;
  }

  HasThisAmbitMessageBeenSeenAlready(CheckAmbitMessageIdInteger: number):boolean 
  {
    // Check to see if the input AmbitMessageId is the latest seen by the user
    if (this.consoleLog) console.log("LatestAmbitMessage.HasThisAmbitMessageBeenSeenAlready - check AmbitMessageId:" + CheckAmbitMessageIdInteger);

    if (this.AmbitMessageId === 0)
    {
      // assume this AMBIT MESSAGE has not been seen yet
      if (this.consoleLog) console.log("LatestAmbitMessage.HasThisAmbitMessageBeenSeenAlready - ASSUME NOT SEEN as no previously stored found");
      //this.AmbitMessageId = CheckAmbitMessageIdInteger; // do this in the call to this.globalProvider.SetStorageObject_LatestAmbitMessage()
      return false;  // *** SHOW THIS AMBIT MESSAGE ***
    }

    if (this.AmbitMessageId < CheckAmbitMessageIdInteger) 
    {
      if (this.consoleLog) console.log("LatestAmbitMessage.HasThisAmbitMessageBeenSeenAlready - NOT SEEN YET - last seen " + this.AmbitMessageId + " < active " + CheckAmbitMessageIdInteger);
      //this.AmbitMessageId = CheckAmbitMessageIdInteger; // do this in the call to this.globalProvider.SetStorageObject_LatestAmbitMessage()
      return false;  // *** SHOW THIS AMBIT MESSAGE ***
    }

    // at this point we know we are looking at the latest AMBIT MESSAGE
    if (this.AmbitMessageId === CheckAmbitMessageIdInteger) 
    {
      if (this.consoleLog) console.log("LatestAmbitMessage.HasThisAmbitMessageBeenSeenAlready - ALREADY SEEN - last seen " + this.AmbitMessageId + " === active " + CheckAmbitMessageIdInteger);
      return true;  // *** do NOT show this AMBIT MESSAGE ***
    }

    // at this point we know we are looking at the latest AMBIT MESSAGE
    if (this.consoleLog) console.log("LatestAmbitMessage.HasThisAmbitMessageBeenSeenAlready - ALREADY SEEN - last seen " + this.AmbitMessageId + " > active " + CheckAmbitMessageIdInteger);
    return true;  // *** do NOT show this AMBIT MESSAGE ***
  }

  // --------------------------------------------------------------
  // ---------------  LOAD OBJECT FUNCTIONS   ---------------------
  // --------------------------------------------------------------
  public SetFromApiResponse(apiResponse):boolean  // data is ApiResponse
  {
    if (this.consoleLog) console.log("global.LatestAmbitMessage.SetFromApiResponse", apiResponse);

    // ToDo:  -- and do we even care to do this?
    // ToDo:  -- and do we even care to do this?
    // ToDo:  -- and do we even care to do this?
    // ToDo:  -- and do we even care to do this?
    // ToDo:  -- and do we even care to do this?

    return true;
  }

  public SetFromStorage(storedLatestAmbitMessage:any):boolean
  {
    if (this.consoleLog) console.log("global.LatestAmbitMessage.SetFromStorage", storedLatestAmbitMessage);

    try
    {
      if (!storedLatestAmbitMessage) { return false; }

      if (storedLatestAmbitMessage.AmbitMessageId)             this.AmbitMessageId            = this.ConvertValue.ToNumber(storedLatestAmbitMessage.AmbitMessageId, 0);
      if (storedLatestAmbitMessage.EventId)             this.EventId            = this.ConvertValue.ToNumber(storedLatestAmbitMessage.EventId, 0);
      if (storedLatestAmbitMessage.ResponseStatusCode)      this.ResponseStatusCode     = this.ConvertValue.ToString(storedLatestAmbitMessage.ResponseStatusCode, "");
      
      if (this.consoleLog) console.log('global.LatestAmbitMessage.SetFromStorage: values parsed ok', this);
      return true;  //return value in then.
    }
    catch (error)
    {
      console.error("global.LatestAmbitMessage.SetFromStorage ERROR", error);
      return false;
    }
  }
}


@Injectable()
export class LastApiError 
{
  public ErrorFlag:boolean = false;
  public ApiFunctionName:string = "";
  public ApiDatetime:string = "";
  public Message:string = "";
  public Name:string = "";
  public StatusText:string = "";
}

@Injectable()
export class NavData 
{
/*
  , { NavSource: this.NavSource, MobileSupportId: item.EventInfo.AbstractId, item: item 
    , ViewMobileFlag: this.ViewMobileFlag.toString()   // this used upon return to this list screen fromt he child
    , LiveFlag: this.LiveFlag.toString()               // this used upon return to this list screen fromt he child
    } 
*/
  // regular screen navigation    
  public IsNavDataExists:boolean = false; 
  public ParentUrl:string = ""; 
  public SourceUrl:string = "";     
  public TargetUrl:string = "";     
  public AbstractId:number = 0;           // e.g. SurveyId, SupportId, ReportId, etc.
  public EventId:number = 0;          
  public LiveFlag:boolean = true;          
  public ViewMobileFlag:boolean = true; 
  //public PanicInitiatedFromAmbitAppFlag:boolean = false;    // MONITOR SCREEN
  public item:any = {};
  public ViewModel:any = {};    
  public GoBackFlag:boolean = false;   
  public EventLatitudeDecimal:string = "";
  public EventLongitudeDecimal:string = "";
  public EventLocationAccuracy:string = "";     
  public EventSiteId:number = 0; 
  public EventSiteLatitudeDecimal:string = "";
  public EventSiteLongitudeDecimal:string = "";
  public NotificationSourceCode:string = "";  // LIST SCREEN
  public NotificationTypeCode:string = "";    // SURVEY | ACTIONABLE

  // modal related 
  public ModalSurveyFlag:boolean = false; 
  public ModalSurveyUrl:string = "";   
  public ModalSurveyBroadcastId:number = 0;  
  public ModalSurveyNotificationSourceCode:string = "";   // PUSH | UNSEEN
  
  public ModalActionableFlag:boolean = false; 
  public ModalActionableUrl:string = "";   
  public ModalActionableBroadcastId:number = 0;  
  public ModalActionableNotificationSourceCode:string = "";   // PUSH | UNSEEN

  public ModalAmbitMessageFlag:boolean = false; 
  public ModalAmbitMessageUrl:string = "";   
  public ModalAmbitMessageId:number = 0;  
  public ModalAmbitMessageNotificationSourceCode:string = "";   // PUSH | UNSEEN
  
  private ConvertValue:ConvertValue = new ConvertValue();
  consoleLog:boolean = false;

  constructor() 
  {
    if (this.consoleLog) console.log('GlobalProvider.NavData.ctor - LifeCycle');
  } 

  Initialize(context:string)
  { 
    this.InitNav(context);
    this.InitSurveyModal(context);
    this.InitActionableModal(context);
    this.InitAmbitMessageModal(context);
  }    

  InitNav(context:string)
  {  
    if (this.consoleLog) console.log("global.NavData.InitNav - " + context);
    this.IsNavDataExists = false;
    this.ParentUrl = "";
    this.SourceUrl = "";     
    this.TargetUrl = "";     
    this.AbstractId = 0;           // e.g. SurveyId, SupportId, ReportId, etc.
    this.EventId = 0;          
    this.LiveFlag = true;          
    this.ViewMobileFlag = true;  
    //this.PanicInitiatedFromAmbitAppFlag = false;
    this.item = {};
    this.ViewModel = {};  
    this.GoBackFlag = true;   
    this.EventLatitudeDecimal = "";
    this.EventLongitudeDecimal = "";
    this.EventLocationAccuracy = "";     
    this.EventSiteId = 0;
    this.EventSiteLatitudeDecimal = "";
    this.EventSiteLongitudeDecimal = "";
    this.NotificationSourceCode = "";
    this.NotificationTypeCode = "";
  }

  InitSurveyModal(context:string)
  {  
    if (this.consoleLog) console.log("global.NavData.InitSurveyModal - " + context);
    this.ModalSurveyFlag = false; 
    this.ModalSurveyUrl = "";   
    this.ModalSurveyBroadcastId = 0;  
    this.ModalSurveyNotificationSourceCode = "";   // PUSH | UNSEEN
  } 

  InitActionableModal(context:string)
  {  
    if (this.consoleLog) console.log("global.NavData.InitActionableModal - " + context);
    this.ModalActionableFlag = false; 
    this.ModalActionableUrl = "";   
    this.ModalActionableBroadcastId = 0;  
    this.ModalActionableNotificationSourceCode = "";   // PUSH | UNSEEN
  } 

  InitAmbitMessageModal(context:string)
  {  
    if (this.consoleLog) console.log("global.NavData.InitAmbitMessageModal - " + context);
    this.ModalAmbitMessageFlag = false; 
    this.ModalAmbitMessageUrl = "";   
    this.ModalAmbitMessageId = 0;  
    this.ModalAmbitMessageNotificationSourceCode = "";   // PUSH | UNSEEN
  } 

  /*
  public GetPanicInitiatedFromAmbitAppFlag():boolean
  {
    console.log("global.NavData.GetPanicInitiatedFromAmbitAppFlag: " + this.PanicInitiatedFromAmbitAppFlag);
    return this.PanicInitiatedFromAmbitAppFlag;
  }
  */

  public SetFromStorage(storedNavData:any):boolean
  {
    if (this.consoleLog) console.log("global.NavData.SetFromStorage", storedNavData);

    try
    {
      if (!storedNavData) { return false; }

      if (storedNavData.IsNavDataExists) this.IsNavDataExists = this.ConvertValue.ToBoolean(storedNavData.IsNavDataExists, false);         
      if (storedNavData.ParentUrl)       this.ParentUrl       = this.ConvertValue.ToString(storedNavData.ParentUrl, "");
      if (storedNavData.SourceUrl)       this.SourceUrl       = this.ConvertValue.ToString(storedNavData.SourceUrl, "");    
      if (storedNavData.TargetUrl)       this.TargetUrl       = this.ConvertValue.ToString(storedNavData.TargetUrl, "");     
      if (storedNavData.AbstractId)      this.AbstractId      = this.ConvertValue.ToNumber(storedNavData.AbstractId, 0);
      if (storedNavData.EventId)         this.EventId         = this.ConvertValue.ToNumber(storedNavData.EventId, 0);          
      if (storedNavData.LiveFlag)        this.LiveFlag        = this.ConvertValue.ToBoolean(storedNavData.LiveFlag, true);         
      if (storedNavData.ViewMobileFlag)  this.ViewMobileFlag  = this.ConvertValue.ToBoolean(storedNavData.ViewMobileFlag, true); 
      //if (storedNavData.item) = = {};
      //if (storedNavData.ViewModel = {};  
      if (storedNavData.GoBackFlag)      this.GoBackFlag     = this.ConvertValue.ToBoolean(storedNavData.GoBackFlag, true);  
      if (storedNavData.EventLatitudeDecimal)   this.EventLatitudeDecimal  = this.ConvertValue.ToString(storedNavData.EventLatitudeDecimal, "");  
      if (storedNavData.EventLongitudeDecimal)  this.EventLongitudeDecimal = this.ConvertValue.ToString(storedNavData.EventLongitudeDecimal, "");  
      if (storedNavData.EventLocationAccuracy)  this.EventLocationAccuracy = this.ConvertValue.ToString(storedNavData.EventLocationAccuracy, "");  
      
      if (storedNavData.EventSiteId)                this.EventSiteId               = this.ConvertValue.ToNumber(storedNavData.EventSiteId, 0);
      if (storedNavData.EventSiteLatitudeDecimal)   this.EventSiteLatitudeDecimal  = this.ConvertValue.ToString(storedNavData.EventSiteLatitudeDecimal, "");  
      if (storedNavData.EventSiteLongitudeDecimal)  this.EventSiteLongitudeDecimal = this.ConvertValue.ToString(storedNavData.EventSiteLongitudeDecimal, "");  
      
      if (this.consoleLog) console.log('global.NavData.SetFromStorage: values parsed ok', this);
      return true;  //return value in then.
    }
    catch (error)
    {
      console.error("global.NavData.SetFromStorage ERROR", error);
      return false;
    }
  }   
}

// --------------------------------------------------------------
// ------------------  LANGUAGE STRUCTURE  -----------------------
// --------------------------------------------------------------

/*
@Injectable()
export class LanguageFactory 
{
  public language1:LanguageItem;
  public language2:LanguageItem;
  public language3:LanguageItem;
  public language4:LanguageItem;
  public language5:LanguageItem;
  public language6:LanguageItem;

  constructor()
  {
    this.language1 = this.GetLanguageItem(1);
    this.language2 = this.GetLanguageItem(2);
    this.language3 = this.GetLanguageItem(3);
    this.language4 = this.GetLanguageItem(4);
    this.language5 = this.GetLanguageItem(5);
    this.language6 = this.GetLanguageItem(6);
  }

  // NOTE:  I needed to do this because "ion-segment" is not quite working right with a dynamic list, 
  //        so I had to create these separate items somewhat redundantly
  GetLanguageItem(LanguageId:number):LanguageItem
  {
    let languageItem:LanguageItem = new LanguageItem();

    switch (LanguageId) // .AmbitEventTypeCode
    {
      case 1:
      {
        languageItem.LanguageId = 1;
        languageItem.LanguageCode = "en-US";
        languageItem.LanguageName = "English";
        languageItem.LanguageNativeName = "English";
        languageItem.LanguageRtl = false;
        languageItem.ActiveInd = true;
        break;
      }
      case 2:
      {
        languageItem.LanguageId = 2;
        languageItem.LanguageCode = "ar-AE";
        languageItem.LanguageName = "Arabic";
        languageItem.LanguageNativeName = "عربى";
        languageItem.LanguageRtl = true;
        languageItem.ActiveInd = true;
        break;
      }
      case 3:
      {
        languageItem.LanguageId = 3;
        languageItem.LanguageCode = "es-MX";
        languageItem.LanguageName = "Spanish";
        languageItem.LanguageNativeName = "Español";
        languageItem.LanguageRtl = false;
        languageItem.ActiveInd = true;
        break;
      }
      case 4:
      {
        languageItem.LanguageId = 4;
        languageItem.LanguageCode = "fr-FR";
        languageItem.LanguageName = "French";
        languageItem.LanguageNativeName = "Français";
        languageItem.LanguageRtl = false;
        languageItem.ActiveInd = true;
        break;
      }
      case 5:
      {
        languageItem.LanguageId = 5;
        languageItem.LanguageCode = "ur";
        languageItem.LanguageName = "Urdu";
        languageItem.LanguageNativeName = "اردو";
        languageItem.LanguageRtl = true;
        languageItem.ActiveInd = true;
        break;
      }
      case 6:
      {
        languageItem.LanguageId = 6;
        languageItem.LanguageCode = "pl";
        languageItem.LanguageName = "Polish";
        languageItem.LanguageNativeName = "Polskie";
        languageItem.LanguageRtl = false;
        languageItem.ActiveInd = true;
        break;
      }
      default:
      {
        languageItem.LanguageId = 1;
        languageItem.LanguageCode = "en-US";
        languageItem.LanguageName = "English";
        languageItem.LanguageNativeName = "English";
        languageItem.LanguageRtl = false;
        languageItem.ActiveInd = true;
        break;
      }
    }

    return languageItem;
  }
}

@Injectable()
export class LanguageItem 
{
  public LanguageId:number = 0;  
  public LanguageCode:string = ""; //"US-EN";
  public LanguageName:string = ""; //"English";
  public LanguageNativeName:string = ""; // Francois
  public LanguageRtl:boolean = false;
  public ActiveInd:boolean = true;

  //constructor() {} 
}
*/


// --------------------------------------------------------------
// ------------------  HELPER FUNCTIONS   -----------------------
// --------------------------------------------------------------
@Injectable()
export class ConvertValue 
{
  ToBoolean(inValue:any, defaultValue:boolean):boolean
  {
    try
    {
      if ((typeof inValue === 'undefined')  || (inValue === null) || (inValue === "{}"))
      {
        return defaultValue;
      }
  
      // usually we expect "TRUE" to be the value, 
      // but adding other possibilities without doing all the string toUpper conversion
      let myBool = inValue === true || inValue === "TRUE" || inValue === "true" || inValue === "True";
  
      return myBool;
    }
    catch (error)
    {
      console.error("ConvertValue.ConvertToBoolean error: " + inValue, error);
      return defaultValue;
    }
  }
  ToNumber(value:number, defaultValue:number):number
  {
    try
    {
      return value;
    }
    catch (error)
    {
      console.error("ConvertValue.ConvertToNumber error: " + value, error);
      return defaultValue;
    }
  }
  ToString(value:string, defaultValue:string):string
  {
    try
    {
      return value;
    }
    catch (error)
    {
      console.error("ConvertValue.ToString error: " + value, error);
      return defaultValue;
    }
  }
}

